export const translations = {
  de: {
    nav: {
      home: 'Start',
      services: 'Leistungen',
      request: 'Anfragen',
      about: 'Über mich',
      current: 'Aktuell',
      references: 'Referenzen'
    },
    hero: {
      title: 'Moderne Websites für kleine Unternehmen',
      subtitle: 'Schlank, schnell und professionell – ohne komplizierte Technik',
      description: 'Ich erstelle klare, responsive Websites für Handwerker, Praxen und kleine Unternehmen. Kein CMS-Chaos, keine versteckten Kosten – ich kümmere mich um alles.',
      cta: 'Jetzt anfragen'
    },
    features: {
      title: 'Warum mein Ansatz anders ist',
      nocms: {
        title: 'Kein CMS-Stress',
        description: 'Sie müssen kein kompliziertes System lernen. Änderungen mache ich für Sie – einfach per E-Mail anfragen.'
      },
      responsive: {
        title: '100% Responsiv',
        description: 'Ihre Website sieht auf Smartphone, Tablet und Desktop perfekt aus. Mobile Navigation optimiert für Touchbedienung.'
      },
      hosting: {
        title: 'EU-Hosting',
        description: 'Transparente Preise, DSGVO-konform, Server in Europa. Keine versteckten Cloud-Kosten aus Übersee.'
      },
      ownership: {
        title: 'Ihr Code gehört Ihnen',
        description: 'Vollständiger Quellcode in Git-Repository. Keine Abhängigkeit – jeder Entwickler kann übernehmen.'
      }
    },
    comparison: {
      title: 'Welcher Weg passt zu Ihrem Vorhaben?',
      sections: [
        {
          heading: 'Next.js & Supabase',
          description: [
            'Eine moderne Web\u2011Anwendung mit eigener Datenbank. Die Seite reagiert sofort auf Eingaben \u2013 ohne dass bei jedem Klick eine neue Seite geladen wird.'
          ],
          groups: [
            {
              title: 'Vorteile',
              items: [
                'Ideal f\u00fcr alles, was \u00fcber eine reine Visitenkarte hinausgeht: Nutzerkonten, Suche, Karten, Buchungen.',
                'Inhalte lassen sich bequem \u00fcber eine eigene Oberfl\u00e4che pflegen \u2013 ohne Programmierkenntnisse.',
                'Sehr schnelle Bedienung: Die Seite f\u00fchlt sich an wie eine App.',
                'W\u00e4chst mit Ihnen mit \u2013 neue Funktionen lassen sich sp\u00e4ter erg\u00e4nzen.'
              ]
            },
            {
              title: 'Nachteile',
              items: [
                'Aufw\u00e4ndiger in der Entwicklung \u2013 und damit in der Anschaffung teurer.',
                'Etwas h\u00f6here laufende Kosten, da eine Datenbank mitl\u00e4uft.',
                'Mehr bewegliche Teile: Der Betrieb will regelm\u00e4\u00dfig gepflegt werden (das \u00fcbernehme ich).',
                'Braucht einen Node\u2011Server \u2013 den bieten die wenigsten Webhoster an. Wenn Ihre Website bei mir liegt, ist das kein Problem: Mein Server bringt alles mit.'
              ]
            }
          ]
        },
        {
          heading: 'HTMX & PHP',
          description: [
            'Ein bewusst schlanker Ansatz: Die Seiten werden auf dem Server erzeugt und direkt ausgeliefert. Wenig Technik, die kaputtgehen kann.'
          ],
          groups: [
            {
              title: 'Vorteile',
              items: [
                'Sehr robust und langlebig \u2013 wenig Abh\u00e4ngigkeiten, wenig Wartung.',
                'G\u00fcnstiger in Anschaffung und Betrieb; l\u00e4uft auf jedem einfachen Webhosting.',
                'Schnelle Ladezeiten, weil kaum Programmcode im Browser ausgef\u00fchrt wird.',
                'Formulare und E\u2011Mail\u2011Versand sind ohne Umwege eingebaut.'
              ]
            },
            {
              title: 'Nachteile',
              items: [
                'Weniger geeignet f\u00fcr hochinteraktive Anwendungen (z.\u00a0B. Nutzerkonten oder Live\u2011Karten).',
                'Inhalts\u00e4nderungen laufen in der Regel \u00fcber mich, nicht \u00fcber eine eigene Oberfl\u00e4che.'
              ]
            }
          ]
        }
      ],
      recommendation: {
        title: 'Was ich empfehle',
        items: [
          { label: 'Next.js & Supabase', text: 'wenn Ihre Website mehr k\u00f6nnen soll als informieren \u2013 etwa Nutzerkonten, Suche, Karten oder laufend neue Inhalte.' },
          { label: 'HTMX & PHP', text: 'wenn der Umfang \u00fcberschaubar ist, sich Inhalte selten \u00e4ndern und Sie Wert auf niedrige Betriebskosten legen.' },
          { label: '', text: 'Sie m\u00fcssen das nicht allein entscheiden: Im Erstgespr\u00e4ch schauen wir uns Ihr Vorhaben an \u2013 und ich sage Ihnen ehrlich, welcher Weg passt.' }
        ]
      }
    },
    services: {
      title: 'Was ich anbiete',
      websites: {
        title: '1. Kleine, schnelle und unkomplizierte Websites',
        description: 'Ich konzentriere mich auf schlanke Webauftritte, die ohne Ballast auskommen und sich gut pflegen lassen – ideal für:',
        items: [
          'Selbstständige und Freiberufler',
          'kleine Unternehmen',
          'Vereine, Initiativen und Projekte'
        ],
        tech: 'Technisch nutze ich vor allem React oder andere moderne Frameworks. Diese Technik begeistert mich, weil sie schnelle, flexible und langlebige Lösungen ermöglicht.'
      },
      contao: {
        title: '2. Websites mit flexibler Inhaltsverwaltung (Strapi CMS)',
        description: 'Für Websites, die regelmäßig aktualisiert werden sollen, setze ich auf Strapi als Content-Management-System – eine moderne, benutzerfreundliche Lösung, die Ihnen volle Kontrolle über Ihre Inhalte gibt:',
        items: [
          'Intuitive Bedienung: Texte, Bilder und andere Inhalte lassen sich ohne technische Vorkenntnisse bearbeiten',
          'Maximale Flexibilität: Das System passt sich Ihren Anforderungen an, nicht umgekehrt',
          'Zukunftssicher: Strapi ist Open Source, gut dokumentiert und wird aktiv weiterentwickelt'
        ],
        tech: 'Die Kombination aus React im Frontend und Strapi im Backend ergibt eine schlanke, performante Lösung, bei der Sie unabhängig bleiben und Ihre Website jederzeit selbst pflegen können – ohne auf mich angewiesen zu sein.'
      },
      content: {
        title: '3. Texte, Grafiken und Karten',
        intro: 'In all meinen Fachgebieten besitze ich fundierte Expertise und kann für Sie:',
        introLinkText: 'In all meinen Fachgebieten',
        items: [
          'gründlich recherchierte, gut lesbare Texte erstellen, die auf eigener Recherche und Erfahrung beruhen',
          'anschauliche Grafiken, Diagramme und Karten entwickeln, die komplexe Zusammenhänge verständlich machen'
        ],
        note: 'Gerade bei Themen wie Geschichte, Geografie, Demografie, Ökolandbau oder Regionalentwicklung ist es mir wichtig, Inhalte korrekt, differenziert und zugleich zugänglich darzustellen.'
      },
      documentaries: {
        title: '4. Dokumentarfilme von A bis Z',
        description: 'Ein weiteres Steckenpferd von mir ist die Produktion von Dokumentarfilmen. Ich übernehme auf Wunsch die komplette Kette:',
        items: [
          'Themenfindung und Recherche',
          'Drehbuch und Struktur',
          'Erstellung von Grafiken und Bildern',
          'Erstellen der musikalischen Elemente (Intro, Outro, Hintergrundmusik, Songs)',
          'Schnitt mit DaVinci Resolve'
        ],
        result: 'So entsteht aus einer Idee eine in sich schlüssige, gut verständliche Dokumentation – visuell wie inhaltlich stimmig.'
      }
    },
    process: {
      title: 'So läuft\'s ab',
      step1: {
        title: 'Erstgespräch',
        description: 'Wir besprechen Ihre Ziele, Inhalte und Besonderheiten Ihres Unternehmens.'
      },
      step2: {
        title: 'Konzept & Design',
        description: 'Ich entwickle Struktur, Layout und maßgeschneiderte Anfrageformulare.'
      },
      step3: {
        title: 'Umsetzung & Launch',
        description: 'Technische Umsetzung, Domain-Setup und Hosting – alles aus einer Hand.'
      },
      step4: {
        title: 'Laufende Betreuung',
        description: 'Kleinere Änderungen per E-Mail. Ich setze sie zeitnah um.'
      }
    },
    pricing: {
      title: 'Faire, transparente Preise',
      description: 'Keine versteckten Kosten. Kleinere Änderungen sind im jährlichen Betreuungspaket inklusive.',
      included: 'Im Betreuungspaket enthalten:',
      items: [
        'Texte anpassen',
        'Öffnungszeiten ändern', 
        'Bilder austauschen',
        'Kleine inhaltliche Ergänzungen'
      ]
    },
    example: {
      title: 'Zum Beispiel',
      subtitle: 'Eine Website des Umfanges dieser Seite',
      features: [
        '5 Seiten inklusive Impressum und Datenschutzerklärung',
        'Umfangreiches Formular',
        'KI-erstellte Bilder für die Hero-Sektion',
        'Dynamische Karte für den Standort',
        'Dreisprachig',
        'GitHub-Repository mit dem gesamten Quellcode'
      ],
      servicePackage: 'Website inklusive Servicepaket für ein Jahr (.de-Domain, Webspace, kleinere Änderungen und Ergänzungen)',
      priceOneYear: '700 Euro zzgl. Mehrwertsteuer',
      servicePackageThreeYears: 'inklusive Servicepaket für drei Jahre:',
      priceThreeYears: '800 Euro zzgl. Mehrwertsteuer'
    },
    included: {
      title: 'Was bei jeder Website standardmäßig inklusive ist',
      items: [
        {
          title: 'SSL-Verschlüsselung & HTTPS',
          description: 'Sichere Verbindung mit gültigem Zertifikat, automatische Weiterleitung auf https.'
        },
        {
          title: 'DSGVO-konforme Grundkonfiguration',
          description: 'Datenschutzfreundliche Standardeinstellungen für Formulare, Logs und Einbindungen.'
        },
        {
          title: 'Rechtliche Basis-Seiten (technische Umsetzung)',
          description: 'Einbindung von Impressum & Datenschutzerklärung an den richtigen Stellen (z.B. Footer).'
        },
        {
          title: 'Cookie- / Consent-Lösung (falls nötig)',
          description: 'Einrichtung eines Consent-Banners für Cookies, Tracking & externe Dienste.'
        },
        {
          title: 'Datenschutzfreundliche Einbindung externer Dienste',
          description: 'Z.B. YouTube/Maps nur nach Einwilligung, 2-Klick-Lösungen, möglichst wenig Tracking.'
        },
        {
          title: 'Lokal gehostete Webfonts (keine Google-Fonts-Remote-Calls)',
          description: 'Schriften werden auf dem eigenen Server bereitgestellt, nicht von Drittanbietern geladen.'
        },
        {
          title: 'Sicheres Backend & Benutzerverwaltung',
          description: 'Geschützte Logins, sinnvolle Rollenrechte im CMS, aktuelle Sicherheitsupdates.'
        },
        {
          title: 'Automatisierte Backups',
          description: 'Regelmäßige Sicherung von Dateien und Datenbank mit definiertem Wiederherstellungsplan.'
        },
        {
          title: 'Mobile-optimiertes, schnelles Frontend',
          description: 'Responsives Design, Bildoptimierung, Caching und saubere technische SEO-Basis.'
        },
        {
          title: 'Dokumentation der wichtigsten technischen & Datenschutz-Einstellungen',
          description: 'Übersicht, welche Dienste eingebunden sind – als Grundlage für Ihren Anwalt/Datenschutzbeauftragten.'
        },
        {
          title: 'Vollständiges GitHub-Repository',
          description: 'Der Code der Website ist Ihr Eigentum. Wenn Sie wollen, kann jederzeit jemand anders die Pflege Ihrer Website übernehmen.'
        }
      ]
    },
    target: {
      title: 'Die HTMX-Site ist also meistens ideal für',
      description: 'kleine Unternehmen, die selten Änderungen haben und sich nicht mit Technik beschäftigen möchten:',
      items: [
        'Handwerksbetriebe',
        'Arzt- und Zahnarztpraxen',
        'Rechtsanwälte und Steuerberater',
        'Solo-Selbständige',
        'Lokale Dienstleister',
        'Einzelhändler'
      ]
    },
    contact: {
      title: 'Interesse geweckt?',
      description: 'Lassen Sie uns über Ihr Website-Projekt sprechen.',
      email: 'E-Mail senden'
    },
    footer: {
      copyright: '© 2026 alitero.eu  –  Alle Rechte vorbehalten',
      privacy: 'Datenschutz',
      imprint: 'Impressum',
      terms: 'AGB'
    },
    terms: {
      title: 'Allgemeine Geschäftsbedingungen (AGB)',
      introduction: 'Diese Allgemeinen Geschäftsbedingungen regeln die Zusammenarbeit zwischen Alitero (Sören Padel) und dem Auftraggeber.',
      sections: {
        scope: {
          title: '1. Geltungsbereich',
          content: 'Diese AGB gelten für alle Dienstleistungen im Bereich Webentwicklung, Content-Erstellung und Dokumentarfilmproduktion. Abweichende Bedingungen bedürfen der schriftlichen Vereinbarung.'
        },
        services: {
          title: '2. Leistungen',
          content: 'Der Umfang der Leistungen wird individuell vereinbart. Alitero erbringt die Leistungen nach bestem Wissen und Gewissen sowie nach den Regeln der Technik.'
        },
        contract: {
          title: '3. Vertragsschluss',
          content: 'Der Vertrag kommt durch Annahme des Angebots durch den Auftraggeber zustande. Angebote sind freibleibend und unverbindlich, sofern nicht ausdrücklich anders vereinbart.'
        },
        payment: {
          title: '4. Vergütung und Zahlungsbedingungen',
          content: 'Die Vergütung erfolgt nach Aufwand oder Pauschalpreis, wie im Angebot vereinbart. Rechnungen sind innerhalb von 14 Tagen nach Erhalt ohne Abzug zahlbar.'
        },
        liability: {
          title: '5. Haftung',
          content: 'Alitero haftet nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit gesetzlich zulässig.'
        },
        rights: {
          title: '6. Urheberrechte',
          content: 'Der vollständige Quellcode von entwickelten Websites geht mit vollständiger Bezahlung an den Auftraggeber über. Der Auftraggeber erhält ein unbeschränktes Nutzungsrecht.'
        },
        termination: {
          title: '7. Kündigung',
          content: 'Beide Parteien können den Vertrag bei laufenden Projekten mit einer Frist von 14 Tagen kündigen. Bereits erbrachte Leistungen sind anteilig zu vergüten.'
        },
        law: {
          title: '8. Anwendbares Recht',
          content: 'Es gilt schwedisches Recht. Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz von Alitero in Schweden.'
        }
      }
    },
    currentPage: {
      heroTitle: 'GeoAtrium',
      heroSubtitle: 'Entdecke die Welt',
      heroDescription: 'Finde die besten Orte und teile Deine Entdeckungen',
      sectionTitle: 'GeoAtrium: Digitale Bürgerkarte für KMU, Behörden, Vereine und privat',
      visitLink: 'Zur Website',
      mapTitle: 'Interaktive Karte'
    },
    references: {
      heroLabel: 'Portfolio',
      heroTitle: 'Referenzen & Videos',
      heroDescription: 'Ausgewählte Projekte und Einblicke in meine Arbeit',
      websitesTitle: 'Web-Projekte',
      websitesSubtitle: 'Websites, die ich für Kunden und eigene Projekte entwickelt habe',
      videosTitle: 'Videos IT',
      videosSubtitle: 'Einblicke, Tutorials und Projektvorstellungen auf YouTube',
      visitWebsite: 'Website besuchen',
      watchVideos: 'Videos ansehen',
      websites: {
        svansele: 'Ökologisch produzieren – selber veredeln – direkt vermarkten: Svansele Grönt im Norden Schwedens.',
        geoimage: 'Digitale Bürgerkarte für Tourismus und Verwaltung in der EU.',
        norsjo: 'Lokale GeoAtrium-Instanz für die Gemeinde Norsjö in Schweden.',
        hrLanding: 'Moderne Landingpage für HR- und Recruiting-Dienstleistungen.',
        demografie: 'Bevölkerungsentwicklung verstehen',
        geschichteInKarten: 'Videos zu geschichtlichen Themen mit starkem Fokus auf Karten',
        schwedenPraktisch: 'Jenseits von Bullerbü – wie funktioniert das richtige Schweden im richtigen Leben, so ganz ohne Elch und Urlaubsromantik',
        liedzeit: 'Gute Musik und gute Texte, ohne Genre-Dogmatismus',
        nybyggare: 'Wir glauben, es ist an der Zeit, die kleinbäuerliche Tradition in Nordschweden wiederzubeleben. Und wie damals sollten auch heute wieder Siedler aus anderen Regionen helfen, das zu bewältigen',
        vidento: 'Schauet! Bücher für alle, die sich Ihre Quellen selber suchen, die in der Lage und willens sind, tiefer zu graben als es die Blase verlangt.Unsere Themenschwerpunkte: Neuere und Zeitgeschichte, Demografie sowie nun auch Kinder- und Jugendliteratur. '
      },
      videos: {
        video1Title: 'Projekt-Vorstellung',
        video1Desc: 'Überblick über aktuelle Web-Projekte und Technologien.',
        video2Title: 'Technische Einblicke',
        video2Desc: 'Hinter den Kulissen: Entwicklungsprozess und Tools.',
        video3Title: 'Demo & Walkthrough',
        video3Desc: 'Live-Demo einer Projektentwicklung von Anfang bis Ende.',
        video4Title: 'HTMX und PHP – eine unschlagbare Kombination?',
        video4Desc: 'Viele Unternehmen stehen vor der Stack‑Wahl: das beliebte Next.js mit React und großem Ökosystem versus den pragmatischen Mix aus HTMX, Tailwind und PHP. Entscheidend sind nicht „Coolness", sondern laufende Kosten, Wartbarkeit und Betriebsrealität.',
      },
    },
    cookieBanner: {
      title: 'Cookie-Hinweis',
      message: 'Diese Website nutzt Umami Analytics zur anonymen Nutzungsanalyse ohne Personenbezug. Es werden keine Tracking-Cookies gesetzt. Wenn Sie die Seite weiter nutzen, stimmen Sie der anonymen Analyse zu.',
      accept: 'Verstanden',
      privacy: 'Datenschutz'
    },
    privacyPolicy: {
      title: 'Datenschutzerklärung',
      lastUpdated: 'Zuletzt aktualisiert',
      introduction: 'Wir nehmen den Schutz Ihrer Daten sehr ernst. Diese Datenschutzerklärung informiert Sie darüber, wie wir Ihre personenbezogenen Daten verarbeiten.',
      sections: {
        responsible: {
          title: '1. Verantwortlicher',
          content: 'Verantwortlicher für die Verarbeitung personenbezogener Daten im Sinne der DSGVO ist: Sören Padel, Örträsk 48, 935 93 Norsjö, Schweden, info@alitero.eu, +49 157 3004 1651'
        },
        dataCollection: {
          title: '2. Erhebung und Verarbeitung von Daten',
          intro: 'Wir erheben und verarbeiten personenbezogene Daten nur, wenn dies rechtlich zulässig ist und einen konkreten Zweck verfolgt. Die Daten werden wie folgt verarbeitet:',
          contact: 'Kontaktformulare: Wenn Sie unser Kontaktformular nutzen, erheben wir Name, E-Mail-Adresse und weitere von Ihnen eingegebene Informationen. Diese Daten werden ausschließlich zur Beantwortung Ihrer Anfrage verarbeitet.',
          analytics: 'Website-Analytik: Wir nutzen keine Tracking-Tools von Drittanbietern, die Ihre Daten an externe Server senden.'
        },
        purposes: {
          title: '3. Zwecke der Datenverarbeitung',
          intro: 'Ihre Daten werden für folgende Zwecke verarbeitet:',
          items: [
            'Beantwortung von Anfragen über das Kontaktformular',
            'Kommunikation mit Ihnen bezüglich geplanter oder durchgeführter Webseiten-Projekte',
            'Erfüllung rechtlicher Verpflichtungen (z.B. Aufbewahrung von Geschäftsunterlagen)'
          ]
        },
        legalBasis: {
          title: '4. Rechtsgrundlage',
          content: '**Rechtsgrundlage für die Verarbeitung personenbezogener Daten**\n\nDie Verarbeitung Ihrer personenbezogenen Daten erfolgt in Übereinstimmung mit Artikel 6 Absatz 1 der Datenschutz-Grundverordnung (DSGVO) der Europäischen Union sowie dem deutschen Bundesdatenschutzgesetz (BDSG). Wir verarbeiten Ihre personenbezogenen Daten auf Grundlage folgender Rechtsgrundlagen:\n\n**Erfüllung eines Vertrags (Artikel 6 Absatz 1 Buchstabe b DSGVO):** Wir verarbeiten Ihre personenbezogenen Daten, wenn dies zur Erfüllung eines Vertrags mit Ihnen oder zur Durchführung vorvertraglicher Maßnahmen auf Ihre Anfrage hin erforderlich ist.\n\n**Einwilligung (Artikel 6 Absatz 1 Buchstabe a DSGVO):** In bestimmten Fällen verarbeiten wir Ihre personenbezogenen Daten, nachdem Sie uns Ihre ausdrückliche Einwilligung erteilt haben. Sie haben jederzeit das Recht, Ihre Einwilligung zu widerrufen.\n\n**Berechtigtes Interesse (Artikel 6 Absatz 1 Buchstabe f DSGVO):** Wir können Ihre personenbezogenen Daten verarbeiten, wenn dies zur Wahrung unserer berechtigten Interessen erforderlich ist, sofern nicht Ihre Interessen oder Grundrechte und Grundfreiheiten überwiegen. Solche berechtigten Interessen können die Verbesserung unserer Dienstleistungen, Sicherheit und Marketing umfassen.\n\n**Rechtliche Verpflichtung (Artikel 6 Absatz 1 Buchstabe c DSGVO):** Wir verarbeiten Ihre personenbezogenen Daten, wenn wir dazu gesetzlich verpflichtet sind, zum Beispiel für Buchführungszwecke.'
        },
        dataSharing: {
          title: '5. Weitergabe an Dritte',
          content: 'Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, es sei denn, dies ist rechtlich erforderlich (z.B. zur Erfüllung gesetzlicher Verpflichtungen) oder Sie haben ausdrücklich zugestimmt. Ihre Daten werden insbesondere nicht zu Marketingzwecken an Dritte weitergegeben.'
        },
        storage: {
          title: '6. Speicherdauer',
          content: 'Ihre personenbezogenen Daten werden nur so lange gespeichert, wie dies für die Zweckerfüllung notwendig ist. Nach Abschluss eines Projekts oder bei Ablehnung einer Anfrage werden Ihre Daten spätestens nach 3 Jahren gelöscht, sofern nicht längere Speicherfristen gesetzlich vorgeschrieben sind (z.B. für Geschäftsunterlagen).'
        },
        rights: {
          title: '7. Ihre Rechte',
          intro: 'Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten (Art. 15-22 DSGVO):',
          items: [
            'Recht auf Auskunft: Sie können jederzeit Auskunft über die von uns gespeicherten personenbezogenen Daten erhalten.',
            'Recht auf Berichtigung: Sie können unrichtige Daten korrigieren lassen.',
            'Recht auf Löschung: Sie können unter bestimmten Bedingungen die Löschung Ihrer Daten verlangen.',
            'Recht auf Einschränkung: Sie können verlangen, dass die Verarbeitung Ihrer Daten eingeschränkt wird.',
            'Recht auf Datenportabilität: Sie können Ihre Daten in strukturierter, gängiger und maschinenlesbarer Form erhalten.',
            'Widerspruchsrecht: Sie können der Verarbeitung widersprechen.'
          ]
        },
        contact: {
          title: '8. Kontaktaufnahme für Datenschutzanliegen',
          content: 'Wenn Sie Ihre Rechte geltend machen möchten oder Fragen zum Datenschutz haben, kontaktieren Sie uns unter: [E-Mail], [Telefon].'
        },
        cookies: {
          title: '9. Cookies und ähnliche Technologien',
          content: 'Diese Website verwendet keine personenbezogenen Tracking-Cookies. Zur Verbesserung unseres Angebots setzen wir Umami Analytics ein, ein datenschutzfreundliches Analyse-Tool, das Besucherdaten vollständig anonymisiert erfasst. Es werden keine IP-Adressen gespeichert und keine personenbezogenen Daten erhoben. Die Analyse dient ausschließlich statistischen Zwecken.'
        },
        security: {
          title: '10. Datensicherheit',
          content: 'Wir setzen technische und organisatorische Maßnahmen um, um Ihre Daten vor Missbrauch, Verlust und unbefugtem Zugriff zu schützen. Alle Übertragungen erfolgen über sichere HTTPS-Verbindungen. Allerdings können wir absolute Sicherheit nicht garantieren.'
        },
        thirdParties: {
          title: '11. Externe Dienste',
          intro: 'Diese Website bindet folgende externe Dienste ein:',
          umami: 'Umami Analytics: Zur anonymen Nutzungsanalyse. Es werden keine personenbezogenen Daten erfasst. Weitere Informationen: https://umami.is/docs/privacy',
          staticforms: 'Formularverarbeitung: Ihre Anfragen werden ausschliesslich auf unserem eigenen Server in Deutschland verarbeitet (Supabase, selbst gehostet) und per E-Mail an uns weitergeleitet. Eine Weitergabe an Drittanbieter findet nicht statt.'
        },
        changes: {
          title: '12. Änderungen dieser Datenschutzerklärung',
          content: 'Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit anzupassen. Änderungen werden auf dieser Seite veröffentlicht. Bitte überprüfen Sie diese regelmäßig.'
        }
      }
    },
    requestForm: {
      title: 'Angebot anfordern',
      subtitle: 'Erzählen Sie mir von Ihrem Vorhaben. Füllen Sie dieses Formular aus, damit ich mir ein erstes Bild machen kann.',
      wizard: {
        step: 'Schritt',
        of: 'von',
        next: 'Weiter',
        back: 'Zurück',
        review: 'Zusammenfassung',
        reviewHint: 'Bitte prüfen Sie Ihre Angaben, bevor Sie die Anfrage absenden.',
        notSpecified: 'Keine Angabe',
        stepNames: {
          1: 'Kontakt & Unternehmen',
          2: 'Website & Umfang',
          3: 'Budget & Zusammenarbeit',
          4: 'Prüfen & Absenden'
        },
        errors: {
          name: 'Bitte geben Sie Ihren Namen an.',
          email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.'
        }
      },
      sections: {
        contact: 'Ihre Kontaktdaten',
        company: 'Ihr Unternehmen',
        website: 'Aktueller Website-Status',
        scope: 'Umfang & Inhalte',
        details: 'Details zum Projekt',
        budget: 'Budget & Zeitrahmen',
        cooperation: 'Zusammenarbeit'
      },
      fields: {
        name: 'Name',
        email: 'E-Mail-Adresse',
        phone: 'Telefonnummer (optional)',
        company: 'Firma / Organisation (optional)',
        industry: 'Branche / Tätigkeitsbereich',
        location: 'Standort (Ort / Land)',
        websiteLink: 'Link zur bestehenden Website',
        goals: 'Was soll Ihre Website für Sie leisten?',
        notes: 'Gibt es etwas, das Ihnen bei der Zusammenarbeit besonders wichtig ist?',
        otherLanguage: 'Weitere Sprache',
        otherScope: 'Sonstiges / Spezielle Anforderungen'
      },
      options: {
        status: {
          none: 'Wir haben noch keine Website.',
          new: 'Wir haben eine Website, möchten aber eine neue.',
          relaunch: 'Unsere Website soll überarbeitet werden.'
        },
        scope: {
          home: 'Startseite / Übersicht',
          services: 'Leistungen / Angebot',
          about: 'Über uns / Team',
          contact: 'Kontaktseite',
          forms: 'Individuelle Anfrageformulare',
          blog: 'Blog / Aktuelles',
          multi: 'Mehrsprachigkeit',
          other: 'Sonstiges / Spezielle Anforderungen'
        },
        languages: {
          de: 'Deutsch',
          en: 'Englisch',
          sv: 'Schwedisch',
          hu: 'Ungarisch',
          other: 'Weitere'
        },
        budget: {
          label: 'Budget-Einschätzung (unverbindlich)',
          unknown: 'Ich habe noch keinen genauen Eindruck',
          small: 'Kleinerer Rahmen (einfache, kompakte Website)',
          medium: 'Mittlerer Rahmen (mehrere Unterseiten)',
          large: 'Größerer Rahmen (spezielle Anforderungen)'
        },
        timeline: {
          label: 'Zeitlicher Rahmen',
          asap: 'So bald wie möglich',
          months: 'In den nächsten 1–3 Monaten',
          later: 'Später, ich sammle erst Informationen'
        },
        support: {
          maintenance: 'Ich wünsche mir laufende Betreuung (inkl. Änderungen).',
          hosting: 'Domain und Hosting sollen organisiert werden.'
        }
      },
      privacy: {
        text: 'Mit dem Absenden des Formulars erklären Sie sich damit einverstanden, dass ich Ihre Angaben zur Bearbeitung Ihrer Anfrage verarbeite.',
        checkbox: 'Ja, ich habe die Datenschutzerklärung gelesen und bin einverstanden.'
      },
      submit: 'Unverbindliche Anfrage senden',
      success: 'Vielen Dank für Ihre Anfrage! Ich werde mich in Kürze bei Ihnen melden.',
      errorSend: 'Die Anfrage konnte nicht versendet werden. Bitte versuchen Sie es später erneut oder schreiben Sie an info@alitero.eu.',
      errorRateLimited: 'Zu viele Anfragen. Bitte versuchen Sie es später erneut oder schreiben Sie an info@alitero.eu.',
      errorDisposable: 'Bitte verwenden Sie eine dauerhafte E‑Mail‑Adresse – an Wegwerf‑Adressen können wir nicht antworten.',
      errorStale: 'Das Formular war zu lange geöffnet. Bitte laden Sie die Seite neu und senden Sie es erneut.'
    },
    imprint: {
      title: 'Impressum',
      lastUpdated: 'Zuletzt aktualisiert',
      introduction: 'Angaben gemäß TMG und ECG',
      sections: {
        responsible: {
          title: 'Verantwortlich für den Inhalt',
          name: 'Sören Padel',
          address: 'Örträsk 48, 935 93 Norsjö, Schweden',
          email: 'E-Mail: info@alitero.eu',
          phone: 'Telefon: +49 157 3004 1651'
        },
        eu: {
          title: 'EU-Streitbeilegung',
          content: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Diese Plattform finden Sie unter https://ec.europa.eu/consumers/odr/'
        },
        liability: {
          title: 'Haftungsausschluss',
          intro: 'Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Die Betreiber der verlinkten Seiten sind allein für deren Inhalte verantwortlich.',
          accuracy: 'Die Inhalte dieser Website werden sorgfältig und gewissenhaft erstellt und regelmäßig aktualisiert. Trotz aller Sorgfalt können wir keine Gewähr für die Aktualität, Richtigkeit und Vollständigkeit aller Inhalte übernehmen.',
          liability_clause: 'Haftungsansprüche gegen den Autor, die sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.'
        },
        copyright: {
          title: 'Urheberrecht',
          content: 'Die auf dieser Website veröffentlichten Inhalte sind urheberrechtlich geschützt. Jede vom Urheberrecht nicht zugelassene Verwertung bedarf der vorherigen ausdrücklichen Zustimmung des Autors oder Rechtsinhabers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung in elektronischen Systemen und Verbreitung.'
        },
        dataprivacy: {
          title: 'Datenschutz',
          content: 'Wir nehmen den Schutz Ihrer persönlichen Daten ernst. Informationen zu unserer Datenschutzerklärung finden Sie unter dem Menüpunkt "Datenschutz".'
        },
        disclaimer: {
          title: 'Haftungsausschluss für Inhalte',
          content: 'Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 des Telemediengesetzes (TMG) sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.'
        }
      }
    },
    about: {
      title: 'Über mich – Sören Padel / Alitero',
      greeting: 'Hallo,',
      intro: 'ich heiße Sören Padel. Alitero ist ein lateinbasierter Neologismus und beschreibt denjenigen, der Dinge bewusst ein wenig anders angeht.',
      aliteroMeaning: 'Genau das ist mein Anspruch: Lösungen, die nicht von der Stange kommen, sondern zu Ihnen und Ihrem Projekt passen.',
      background: {
        title: 'Fachlicher Hintergrund',
        intro: 'Seit rund 25 Jahren entwickle ich Websites – zuerst aus persönlichem Interesse und für eigene Projekte, inzwischen auch professionell gewerblich. Eigentlich bin ich:',
        roles: [
          'Historiker',
          'IT-affiner Geograf – und damit auch Kartograf und Demograf',
          'Pädagoge und Schwedenkenner',
          'mit langjähriger Erfahrung im ökologischen Landbau und in der Regionalentwicklung'
        ],
        summary: 'Diese Mischung aus Geistes- und Geowissenschaften, Praxis in Landwirtschaft und Regionalentwicklung sowie pädagogischer Erfahrung ist die Grundlage meiner Arbeit: Ich kann recherchieren, strukturieren, verständlich erklären und Inhalte so aufbereiten, dass sie für Ihre Zielgruppen greifbar werden.'
      },
      tools: {
        title: 'Mit welchen Programmen ich am liebsten arbeite',
        intro: 'In meiner Werkzeugkiste befinden sich unter anderem:',
        items: [
          { category: 'Entwicklung', tool: 'VSCodium' },
          { category: 'Daten', tool: 'RStudio' },
          { category: 'Karten & GIS', tool: 'QGIS, OpenLayers' },
          { category: 'Medien', tool: 'Affinity Suite, Fooocus, DaVinci Resolve Studio, Audacity, OBS Studio' },
          { category: 'Wissenschaftliche Arbeiten', tool: 'TeXstudio, Zotero' },
          { category: 'Zusammenarbeit & Dateiablage', tool: 'Nextcloud' }
        ],
        conclusion: 'Meine Arbeitsumgebung ist bewusst interdisziplinär angelegt. Wo es passt, setze ich auf Open Source – nicht als Selbstzweck, sondern um Abhängigkeiten zu reduzieren und Projekte langfristig gut wartbar zu halten.'
      },
      personal: {
        title: 'Wer ich abseits des Bildschirms bin',
        intro: 'In meiner Freizeit bin ich:',
        hobbies: [
          'Imker',
          'Diensthunde-Sportler',
          'Hobbybrauer'
        ],
        conclusion: 'Diese Tätigkeiten haben eines gemeinsam: Sie erfordern Geduld, Genauigkeit, Verantwortung und den Blick für das Ganze. Genau diese Haltung prägt auch meine Arbeit an Websites, Texten, Grafiken und Dokumentationen.'
      },
      cta: {
        welcome: 'Herzlich willkommen bei Alitero.',
        message: 'Wenn Sie eine Website, Texte oder eine Dokumentation suchen, die fachlich solide, verständlich und mit Liebe zum Detail umgesetzt sind, freue ich mich auf Ihre Nachricht.',
        signature: 'Ihr Sören Padel',
        button: 'Jetzt anfragen'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      request: 'Request Project',
      about: 'About Me',
      current: 'Current',
      references: 'References'
    },
    hero: {
      title: 'Modern Websites for Small Businesses',
      subtitle: 'Lean, fast and professional – without complicated technology',
      description: 'I create clear, responsive websites for craftsmen, practices and small businesses. No CMS chaos, no hidden costs – I take care of everything.',
      cta: 'Get in touch'
    },
    features: {
      title: 'Why my approach is different',
      nocms: {
        title: 'No CMS Stress',
        description: 'You don\'t need to learn a complicated system. I make changes for you – just request via email.'
      },
      responsive: {
        title: '100% Responsive',
        description: 'Your website looks perfect on smartphone, tablet and desktop. Mobile navigation optimized for touch operation.'
      },
      hosting: {
        title: 'EU Hosting',
        description: 'Transparent prices, GDPR compliant, servers in Europe. No hidden cloud costs from overseas.'
      },
      ownership: {
        title: 'Your Code Belongs to You',
        description: 'Complete source code in Git repository. No dependency – any developer can take over.'
      }
    },
    comparison: {
      title: 'Which approach fits your project?',
      sections: [
        {
          heading: 'Next.js & Supabase',
          description: [
            'A modern web application with its own database. The site responds instantly \u2013 without reloading a new page on every click.'
          ],
          groups: [
            {
              title: 'Advantages',
              items: [
                'Ideal for anything beyond a digital business card: user accounts, search, maps, bookings.',
                'Content can be managed conveniently through a dedicated interface \u2013 no coding required.',
                'Very responsive: the site feels like an app.',
                'Grows with you \u2013 new features can be added later.'
              ]
            },
            {
              title: 'Disadvantages',
              items: [
                'More complex to build \u2013 and therefore more expensive up front.',
                'Slightly higher running costs, since a database is involved.',
                'More moving parts: operations need regular maintenance (which I take care of).',
                'Requires a Node server \u2013 which hardly any web host offers. If your site is hosted with me, that is not an issue: my server has everything it needs.'
              ]
            }
          ]
        },
        {
          heading: 'HTMX & PHP',
          description: [
            'A deliberately lean approach: pages are generated on the server and delivered directly. Little technology that can break.'
          ],
          groups: [
            {
              title: 'Advantages',
              items: [
                'Very robust and long-lasting \u2013 few dependencies, little maintenance.',
                'Cheaper to build and run; works on any basic web hosting.',
                'Fast loading times, since hardly any code runs in the browser.',
                'Forms and email delivery are built in without detours.'
              ]
            },
            {
              title: 'Disadvantages',
              items: [
                'Less suited to highly interactive applications (e.g. user accounts or live maps).',
                'Content changes usually go through me, rather than a dedicated interface.'
              ]
            }
          ]
        }
      ],
      recommendation: {
        title: 'What I recommend',
        items: [
          { label: 'Next.js & Supabase', text: 'if your website should do more than inform \u2013 such as user accounts, search, maps or a steady stream of new content.' },
          { label: 'HTMX & PHP', text: 'if the scope is manageable, content rarely changes and you value low running costs.' },
          { label: '', text: 'You do not have to decide alone: in our first conversation we look at your project \u2013 and I tell you honestly which approach fits.' }
        ]
      }
    },
    services: {
      title: 'What I offer',
      websites: {
        title: '1. Small, fast and uncomplicated websites',
        description: 'I focus on lean web presences that work without ballast and are easy to maintain – ideal for:',
        items: [
          'Self-employed and freelancers',
          'Small businesses',
          'Associations, initiatives and projects'
        ],
        tech: 'Technically, I mainly use React or other modern frameworks. This technology excites me because it enables fast, flexible and long-lasting solutions.'
      },
      contao: {
        title: '2. Websites with Flexible Content Management (Strapi CMS)',
        description: 'For websites that need regular updates, I rely on Strapi as a content management system – a modern, user-friendly solution that gives you full control over your content:',
        items: [
          'Intuitive operation: Texts, images and other content can be edited without technical knowledge',
          'Maximum flexibility: The system adapts to your requirements, not the other way around',
          'Future-proof: Strapi is open source, well documented and actively developed'
        ],
        tech: 'The combination of React in the frontend and Strapi in the backend results in a lean, high-performance solution where you remain independent and can maintain your website yourself at any time – without being dependent on me.'
      },
      content: {
        title: '3. Texts, graphics and maps',
        intro: 'In all my fields of expertise, I have sound knowledge and can provide you with:',
        introLinkText: 'In all my fields of expertise',
        items: [
          'thoroughly researched, well-readable texts based on my own research and experience',
          'illustrative graphics, diagrams and maps that make complex relationships understandable'
        ],
        note: 'Especially for topics such as history, geography, demography, organic farming or regional development, it is important to me to present content correctly, differentiated and yet accessible.'
      },
      documentaries: {
        title: '4. Documentaries from A to Z',
        description: 'Another specialty of mine is the production of documentaries. On request, I take over the complete chain:',
        items: [
          'Topic finding and research',
          'Script and structure',
          'Creation of graphics and images',
          'Creation of musical elements (intro, outro, background music, songs)',
          'Editing with DaVinci Resolve'
        ],
        result: 'This way, an idea becomes a coherent, well-understandable documentary – visually and content-wise consistent.'
      }
    },
    process: {
      title: 'How it works',
      step1: {
        title: 'Initial Meeting',
        description: 'We discuss your goals, content and special features of your business.'
      },
      step2: {
        title: 'Concept & Design',
        description: 'I develop structure, layout and customized inquiry forms.'
      },
      step3: {
        title: 'Implementation & Launch',
        description: 'Technical implementation, domain setup and hosting – everything from one source.'
      },
      step4: {
        title: 'Ongoing Support',
        description: 'Minor changes via email. I implement them promptly.'
      }
    },
    pricing: {
      title: 'Fair, transparent prices',
      description: 'No hidden costs. Minor changes are included in the annual support package.',
      included: 'Included in support package:',
      items: [
        'Adjust texts',
        'Change opening hours',
        'Replace images', 
        'Small content additions'
      ]
    },
    example: {
      title: 'For Example',
      subtitle: 'A website of the scope of this page',
      features: [
        '5 pages including imprint and privacy policy',
        'Comprehensive contact form',
        'AI-generated images for the hero section',
        'Dynamic map for location',
        'Three languages',
        'GitHub repository with complete source code'
      ],
      servicePackage: 'Website including service package for one year (.de domain, web space, minor changes and additions)',
      priceOneYear: '700 Euro plus VAT',
      servicePackageThreeYears: 'including service package for three years:',
      priceThreeYears: '800 Euro plus VAT'
    },
    included: {
      title: 'What is standard with every website',
      items: [
        {
          title: 'SSL Encryption & HTTPS',
          description: 'Secure connection with valid certificate, automatic redirect to https.'
        },
        {
          title: 'GDPR-Compliant Basic Configuration',
          description: 'Privacy-friendly default settings for forms, logs and integrations.'
        },
        {
          title: 'Legal Base Pages (Technical Implementation)',
          description: 'Integration of imprint & privacy policy in the right places (e.g. footer).'
        },
        {
          title: 'Cookie / Consent Solution (if needed)',
          description: 'Setup of a consent banner for cookies, tracking & external services.'
        },
        {
          title: 'Privacy-Friendly Integration of External Services',
          description: 'E.g. YouTube/Maps only after consent, 2-click solutions, minimal tracking.'
        },
        {
          title: 'Locally Hosted Web Fonts (no Google Fonts remote calls)',
          description: 'Fonts are provided on your own server, not loaded from third parties.'
        },
        {
          title: 'Secure Backend & User Management',
          description: 'Protected logins, sensible role permissions in the CMS, current security updates.'
        },
        {
          title: 'Automated Backups',
          description: 'Regular backup of files and database with defined recovery plan.'
        },
        {
          title: 'Mobile-Optimized, Fast Frontend',
          description: 'Responsive design, image optimization, caching and clean technical SEO basis.'
        },
        {
          title: 'Documentation of Important Technical & Privacy Settings',
          description: 'Overview of which services are integrated – as a basis for your lawyer/data protection officer.'
        },
        {
          title: 'Complete GitHub Repository',
          description: 'The code of your website is your property. If you wish, someone else can take over the maintenance of your website at any time.'
        }
      ]
    },
    target: {
      title: 'So my HTMX site is usually ideal for',
      description: 'small businesses that rarely have changes and don\'t want to deal with technology:',
      items: [
        'Craft businesses',
        'Medical and dental practices',
        'Lawyers and tax advisors',
        'Solo entrepreneurs',
        'Local service providers',
        'Retailers'
      ]
    },
    contact: {
      title: 'Interested?',
      description: 'Let\'s talk about your website project.',
      email: 'Send email'
    },
    footer: {
      copyright: '© 2026 alitero.eu –       All rights reserved',
      privacy: 'Privacy',
      imprint: 'Imprint',
      terms: 'Terms'
    },
    terms: {
      title: 'Terms and Conditions',
      introduction: 'These Terms and Conditions govern the collaboration between Alitero (Sören Padel) and the client.',
      sections: {
        scope: {
          title: '1. Scope',
          content: 'These Terms and Conditions apply to all services in web development, content creation and documentary production. Deviating conditions require written agreement.'
        },
        services: {
          title: '2. Services',
          content: 'The scope of services is agreed individually. Alitero provides services to the best of their knowledge and in accordance with the rules of technology.'
        },
        contract: {
          title: '3. Contract Formation',
          content: 'The contract is formed by the client\'s acceptance of the offer. Offers are subject to change and non-binding unless expressly agreed otherwise.'
        },
        payment: {
          title: '4. Payment and Payment Terms',
          content: 'Payment is based on effort or fixed price as agreed in the offer. Invoices are payable within 14 days of receipt without deduction.'
        },
        liability: {
          title: '5. Liability',
          content: 'Alitero is only liable for intent and gross negligence. Liability for slight negligence is excluded to the extent legally permissible.'
        },
        rights: {
          title: '6. Copyright',
          content: 'The complete source code of developed websites is transferred to the client upon full payment. The client receives an unlimited right of use.'
        },
        termination: {
          title: '7. Termination',
          content: 'Both parties can terminate ongoing projects with 14 days\' notice. Services already provided must be compensated proportionately.'
        },
        law: {
          title: '8. Applicable Law',
          content: 'Swedish law applies. Place of jurisdiction is, to the extent legally permissible, the seat of Alitero in Sweden.'
        }
      }
    },
    currentPage: {
      heroTitle: 'GeoAtrium',
      heroSubtitle: 'Discover the World',
      heroDescription: 'Find the best places and share your discoveries',
      sectionTitle: 'GeoAtrium: Digital Citizen Map for SMEs, Public Authorities, Associations and Private Users',
      visitLink: 'Visit Website',
      mapTitle: 'Interactive Map'
    },
    references: {
      heroLabel: 'Portfolio',
      heroTitle: 'References & Videos',
      heroDescription: 'Selected projects and insights into my work',
      websitesTitle: 'Web Projects',
      websitesSubtitle: 'Websites I have developed for clients and personal projects',
      videosTitle: 'Videos IT',
      videosSubtitle: 'Insights, tutorials and project presentations on YouTube',
      visitWebsite: 'Visit website',
      watchVideos: 'Watch videos',
      websites: {
        svansele: 'Organic production – refine yourself – market directly: Svansele Grönt in northern Sweden.',
        geoimage: 'Digital citizen map for tourism and administration in the EU.',
        norsjo: 'Local GeoAtrium instance for the municipality of Norsjö in Sweden.',
        hrLanding: 'Modern landing page for HR and recruiting services.',
        demografie: 'Understanding population development',
        geschichteInKarten: 'Videos on historical topics with a strong focus on maps',
        schwedenPraktisch: 'Beyond Bullerbü – how real Sweden works in real life, without moose and holiday romance',
        liedzeit: 'Good music and good lyrics, without genre dogmatism',
        nybyggare: 'We believe it\'s time to revive the smallholder tradition in northern Sweden. And as in the old days, settlers from other regions should once again help make this happen',
      },
      videos: {
        video1Title: 'Project Presentation',
        video1Desc: 'Overview of current web projects and technologies.',
        video2Title: 'Technical Insights',
        video2Desc: 'Behind the scenes: development process and tools.',
        video3Title: 'Demo & Walkthrough',
        video3Desc: 'Live demo of a project development from start to finish.',
        video4Title: 'HTMX and PHP – an unbeatable combination?',
        video4Desc: 'Many companies face the stack choice: popular Next.js with React and a large ecosystem versus the pragmatic mix of HTMX, Tailwind and PHP. What matters is not "coolness" but running costs, maintainability and operational reality.',
      },
    },
    cookieBanner: {
      title: 'Cookie Notice',
      message: 'This website uses Umami Analytics for anonymous usage analysis without personal data. No tracking cookies are set. By continuing to use this site, you consent to anonymous analysis.',
      accept: 'Got it',
      privacy: 'Privacy'
    },
    privacyPolicy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated',
      introduction: 'We take the protection of your data very seriously. This privacy policy explains how we process your personal data.',
      sections: {
        responsible: {
          title: '1. Responsible Party',
          content: 'The responsible party for processing personal data within the meaning of the GDPR is: Sören Padel, Örträsk 48. 935 93 Norsjö, Sweden, info@alitero.eu, +49 157 3004 1651.'
        },
        dataCollection: {
          title: '2. Collection and Processing of Data',
          intro: 'We collect and process personal data only when legally permissible and for a specific purpose. The data is processed as follows:',
          contact: 'Contact Forms: When you use our contact form, we collect your name, email address and other information you provide. This data is used exclusively to answer your inquiry.',
          analytics: 'Website Analytics: We do not use third-party tracking tools that send your data to external servers.'
        },
        purposes: {
          title: '3. Purposes of Data Processing',
          intro: 'Your data is processed for the following purposes:',
          items: [
            'Responding to inquiries via the contact form',
            'Communication with you regarding planned or completed website projects',
            'Compliance with legal obligations (e.g., retention of business records)'
          ]
        },
        legalBasis: {
          title: '4. Legal Basis',
          content: '**Legal basis for processing personal data**\n\nThe processing of your personal data is carried out in accordance with Article 6(1) of the European Union\'s General Data Protection Regulation (GDPR) and German data protection law. We process your personal data based on the following legal grounds:\n\n**Performance of a contract (Article 6(1)(b) GDPR):** We process your personal data when necessary to fulfill a contract with you or to take steps at your request before entering into a contract.\n\n**Consent (Article 6(1)(a) GDPR):** In certain cases, we process your personal data after you have given your express consent. You always have the right to withdraw your consent at any time.\n\n**Legitimate interest (Article 6(1)(f) GDPR):** We may process your personal data when necessary for our legitimate interests, unless your interests or fundamental rights and freedoms outweigh ours. Such legitimate interests may include improving our services, security, and marketing.\n\n**Legal obligation (Article 6(1)(c) GDPR):** We process your personal data when we are legally required to do so, for example for accounting purposes.'
        },
        dataSharing: {
          title: '5. Sharing with Third Parties',
          content: 'We do not share your personal data with third parties unless required by law (e.g., for legal obligations) or you have explicitly consented. Your data will not be shared with third parties for marketing purposes.'
        },
        storage: {
          title: '6. Storage Duration',
          content: 'Your personal data is stored only as long as necessary to fulfill the stated purposes. After project completion or rejection of an inquiry, your data will be deleted after a maximum of 3 years, unless longer retention periods are required by law (e.g., for business records).'
        },
        rights: {
          title: '7. Your Rights',
          intro: 'You have the following rights regarding your personal data (Articles 15-22 GDPR):',
          items: [
            'Right to Information: You can request information about your personal data at any time.',
            'Right to Rectification: You can correct inaccurate data.',
            'Right to Erasure: You can request deletion of your data under certain conditions.',
            'Right to Restrict Processing: You can request that processing of your data be restricted.',
            'Right to Data Portability: You can receive your data in a structured, common and machine-readable format.',
            'Right to Object: You can object to the processing of your data.'
          ]
        },
        contact: {
          title: '8. Contact for Data Protection Concerns',
          content: 'If you wish to exercise your rights or have questions about data protection, please contact us at: [Email], [Phone].'
        },
        cookies: {
          title: '9. Cookies and Similar Technologies',
          content: 'This website does not use personal tracking cookies. To improve our services, we use Umami Analytics, a privacy-friendly analytics tool that collects visitor data in a completely anonymized manner. No IP addresses are stored and no personal data is collected. The analysis serves statistical purposes only.'
        },
        security: {
          title: '10. Data Security',
          content: 'We implement technical and organizational measures to protect your data from misuse, loss and unauthorized access. All transmissions are made via secure HTTPS connections. However, we cannot guarantee absolute security.'
        },
        thirdParties: {
          title: '11. External Services',
          intro: 'This website uses the following external services:',
          umami: 'Umami Analytics: For anonymous usage analysis. No personal data is collected. More information: https://umami.is/docs/privacy',
          staticforms: 'Form processing: Your requests are processed exclusively on our own server in Germany (self-hosted Supabase) and forwarded to us by email. No data is passed on to third-party providers.'
        },
        changes: {
          title: '12. Changes to This Privacy Policy',
          content: 'We reserve the right to modify this privacy policy at any time. Changes will be published on this page. Please review it regularly.'
        }
      }
    },
    requestForm: {
      title: 'Request Project',
      subtitle: 'Tell me about your project. Fill out this form so I can get an initial idea.',
      wizard: {
        step: 'Step',
        of: 'of',
        next: 'Next',
        back: 'Back',
        review: 'Summary',
        reviewHint: 'Please review your details before submitting the request.',
        notSpecified: 'Not specified',
        stepNames: {
          1: 'Contact & Company',
          2: 'Website & Scope',
          3: 'Budget & Cooperation',
          4: 'Review & Submit'
        },
        errors: {
          name: 'Please enter your name.',
          email: 'Please enter a valid email address.'
        }
      },
      sections: {
        contact: 'Your Contact Details',
        company: 'Your Company',
        website: 'Current Website Status',
        scope: 'Scope & Content',
        details: 'Project Details',
        budget: 'Budget & Timeline',
        cooperation: 'Collaboration'
      },
      fields: {
        name: 'Name',
        email: 'Email Address',
        phone: 'Phone Number (optional)',
        company: 'Company / Organization (optional)',
        industry: 'Industry / Field of Activity',
        location: 'Location (City / Country)',
        websiteLink: 'Link to existing website',
        goals: 'What should your website achieve for you?',
        notes: 'Is there anything particularly important to you regarding our collaboration?',
        otherLanguage: 'Other Language',
        otherScope: 'Other / Special Requirements'
      },
      options: {
        status: {
          none: 'We do not have a website yet.',
          new: 'We have a website, but want a new one.',
          relaunch: 'Our website needs to be reworked.'
        },
        scope: {
          home: 'Home / Overview',
          services: 'Services / Offer',
          about: 'About Us / Team',
          contact: 'Contact Page',
          forms: 'Custom Inquiry Forms',
          blog: 'Blog / News',
          multi: 'Multilingualism',
          other: 'Other / Special Requirements'
        },
        languages: {
          de: 'German',
          en: 'English',
          sv: 'Swedish',
          hu: 'Hungarian',
          other: 'Other'
        },
        budget: {
          label: 'Budget Estimation (non-binding)',
          unknown: 'I do not have a clear idea yet',
          small: 'Smaller scope (simple, compact website)',
          medium: 'Medium scope (multiple subpages)',
          large: 'Larger scope (special requirements)'
        },
        timeline: {
          label: 'Time Frame',
          asap: 'As soon as possible',
          months: 'In the next 1–3 months',
          later: 'Later, just gathering information'
        },
        support: {
          maintenance: 'I would like ongoing support (incl. changes).',
          hosting: 'Domain and hosting should be organized.'
        }
      },
      privacy: {
        text: 'By submitting this form, you agree that I may process your information to handle your request.',
        checkbox: 'Yes, I have read the privacy policy and agree.'
      },
      submit: 'Send Non-binding Request',
      success: 'Thank you for your request! I will get back to you shortly.',
      errorSend: 'The request could not be sent. Please try again later or email info@alitero.eu.',
      errorRateLimited: 'Too many requests. Please try again later or email info@alitero.eu.',
      errorDisposable: 'Please use a permanent email address – we cannot reply to disposable addresses.',
      errorStale: 'The form was open for too long. Please reload the page and submit again.'
    },
    imprint: {
      title: 'Legal Notice',
      lastUpdated: 'Last Updated',
      introduction: 'Information required by law (TMG and ECG)',
      sections: {
        responsible: {
          title: 'Responsible for Content',
          name: 'Sören Padel',
          address: 'Örträsk 48, 935 93 Norsjö, Sweden',
          email: 'Email: info@alitero.eu',
          phone: 'Phone: +49 157 3004 1651'
        },
        eu: {
          title: 'EU Dispute Resolution',
          content: 'The European Commission provides a platform for online dispute resolution (ODR). You can find this platform at https://ec.europa.eu/consumers/odr/'
        },
        liability: {
          title: 'Disclaimer',
          intro: 'Despite careful and thorough content control, we accept no liability for the contents of external links. The operators of linked pages are solely responsible for their content.',
          accuracy: 'The content of this website is created carefully and conscientiously and updated on a regular basis. However, despite all care, we cannot guarantee the timeliness, accuracy and completeness of all content.',
          liability_clause: 'Claims for damages by the author, which relate to damage of a material or non-material nature caused by the use or non-use of the information presented or by the use of incorrect and incomplete information, are fundamentally excluded.'
        },
        copyright: {
          title: 'Copyright',
          content: 'The content published on this website is protected by copyright. Any use not permitted by copyright law requires the prior express consent of the author or copyright holder. This applies in particular to copying, editing, translation, storage, processing in electronic systems and distribution.'
        },
        dataprivacy: {
          title: 'Data Privacy',
          content: 'We take the protection of your personal data seriously. For information about our privacy policy, please see the "Privacy" section.'
        },
        disclaimer: {
          title: 'Content Liability Disclaimer',
          content: 'As a service provider, we are responsible for our own content on these pages according to general law. However, as a service provider, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.'
        }
      }
    },
    about: {
      title: 'About Me – Sören Padel / Alitero',
      greeting: 'Hello,',
      intro: 'my name is Sören Padel. Alitero is a Latin-based neologism describing someone who consciously approaches things a little differently.',
      aliteroMeaning: 'That is exactly my approach: solutions that are not off-the-shelf, but fit you and your project.',
      background: {
        title: 'Professional Background',
        intro: 'I have been developing websites for about 25 years – first out of personal interest and for my own projects, now also professionally for clients. Actually, I am:',
        roles: [
          'Historian',
          'IT-savvy geographer – and thus also cartographer and demographer',
          'Pedagogue and Sweden expert',
          'with many years of experience in organic farming and regional development'
        ],
        summary: 'This mix of humanities and spatial sciences, practice in agriculture and regional development as well as pedagogical experience is the foundation of my work: I can research, structure, explain clearly and prepare content so that it becomes tangible for your target groups.'
      },
      services: {
        title: 'What I Offer',
        websites: {
          title: '1. Small, Fast and Uncomplicated Websites',
          description: 'I focus on lean web presences that work without ballast and are easy to maintain – ideal for:',
          items: [
            'Self-employed and freelancers',
            'Small businesses',
            'Associations, initiatives and projects'
          ],
          tech: 'Technically, I mainly use React or other modern frameworks. This technology excites me because it enables fast, flexible and long-lasting solutions.'
        },
        contao: {
          title: '2. Websites with Flexible Content Management (Strapi CMS)',
          description: 'For websites that need regular updates, I rely on Strapi as a content management system – a modern, user-friendly solution that gives you full control over your content:',
          items: [
            'Intuitive operation: Texts, images and other content can be edited without technical knowledge',
            'Maximum flexibility: The system adapts to your requirements, not the other way around',
            'Future-proof: Strapi is open source, well documented and actively developed'
          ],
          tech: 'The combination of React in the frontend and Strapi in the backend results in a lean, high-performance solution where you remain independent and can maintain your website yourself at any time – without being dependent on me.'
        },
        content: {
          title: '3. Texts, Graphics and Maps',
          intro: 'In all my fields of expertise, I have sound knowledge and can provide you with:',
          items: [
            'thoroughly researched, well-readable texts based on my own research and experience',
            'illustrative graphics, diagrams and maps that make complex relationships understandable'
          ],
          note: 'Especially for topics such as history, geography, demography, organic farming or regional development, it is important to me to present content correctly, differentiated and yet accessible.'
        },
        documentaries: {
          title: '4. Documentaries from A to Z',
          description: 'Another specialty of mine is the production of documentaries. On request, I take over the complete chain:',
          items: [
            'Topic finding and research',
            'Script and structure',
            'Creation of graphics and images',
            'Editing with DaVinci Resolve'
          ],
          result: 'This way, an idea becomes a coherent, well-understandable documentary – visually and content-wise consistent.'
        }
      },
      tools: {
        title: 'My Favorite Tools and Programs',
        intro: 'In my toolbox you will find, among others:',
        items: [
          { category: 'Development', tool: 'VSCodium' },
          { category: 'Data', tool: 'RStudio' },
          { category: 'Maps & GIS', tool: 'QGIS, OpenLayers' },
          { category: 'Media', tool: 'Affinity Suite, Fooocus, DaVinci Resolve Studio, Audacity, OBS Studio' },
          { category: 'Scientific Work', tool: 'TeXstudio, Zotero' },
          { category: 'Collaboration & File Storage', tool: 'Nextcloud' }
        ],
        conclusion: 'My work environment is deliberately interdisciplinary. Where appropriate, I rely on open source – not for its own sake, but to reduce dependencies and keep projects maintainable in the long term.'
      },
      personal: {
        title: 'Who I Am Away from the Screen',
        intro: 'In my free time, I am:',
        hobbies: [
          'Beekeeper',
          'Service dog athlete',
          'Hobby brewer'
        ],
        conclusion: 'These activities have one thing in common: They require patience, precision, responsibility and an eye for the whole. This attitude also shapes my work on websites, texts, graphics and documentaries.'
      },
      cta: {
        welcome: 'Welcome to Alitero.',
        message: 'If you are looking for a website, texts or a documentary that are professionally solid, understandable and implemented with attention to detail, I look forward to your message.',
        signature: 'Yours, Sören Padel',
        button: 'Get in touch'
      }
    }
  },
  sv: {
    nav: {
      home: 'Hem',
      services: 'Tjänster',
      request: 'Begär Offert',
      about: 'Om Mig',
      current: 'Aktuellt',
      references: 'Referenser'
    },
    hero: {
      title: 'Moderna Webbplatser för Små Företag',
      subtitle: 'Smidig, snabb och professionell – utan komplicerad teknik',
      description: 'Jag skapar tydliga, responsiva webbplatser för hantverkare, praktiker och små företag. Inget CMS-kaos, inga dolda kostnader – jag tar hand om allt.',
      cta: 'Kontakta mig'
    },
    features: {
      title: 'Varför mitt tillvägagångssätt är annorlunda',
      nocms: {
        title: 'Ingen CMS-stress',
        description: 'Du behöver inte lära dig ett komplicerat system. Jag gör ändringar åt dig – bara begär via e-post.'
      },
      responsive: {
        title: '100% Responsiv',
        description: 'Din webbplats ser perfekt ut på smartphone, surfplatta och desktop. Mobil navigation optimerad för pekskärm.'
      },
      hosting: {
        title: 'EU-hosting',
        description: 'Transparenta priser, GDPR-kompatibel, servrar i Europa. Inga dolda molnkostnader från utlandet.'
      },
      ownership: {
        title: 'Din Kod Tillhör Dig',
        description: 'Komplett källkod i Git-repository. Inget beroende – vilken utvecklare som helst kan ta över.'
      }
    },
    comparison: {
      title: 'Vilken v\u00e4g passar ditt projekt?',
      sections: [
        {
          heading: 'Next.js & Supabase',
          description: [
            'En modern webbapplikation med egen databas. Sidan svarar direkt \u2013 utan att ladda om en ny sida vid varje klick.'
          ],
          groups: [
            {
              title: 'F\u00f6rdelar',
              items: [
                'Perfekt f\u00f6r allt som g\u00e5r ut\u00f6ver ett digitalt visitkort: anv\u00e4ndarkonton, s\u00f6k, kartor, bokningar.',
                'Inneh\u00e5llet sk\u00f6ts bekv\u00e4mt via ett eget gr\u00e4nssnitt \u2013 utan programmeringskunskaper.',
                'Mycket snabb i anv\u00e4ndning: sidan k\u00e4nns som en app.',
                'V\u00e4xer med dig \u2013 nya funktioner kan l\u00e4ggas till senare.'
              ]
            },
            {
              title: 'Nackdelar',
              items: [
                'Mer arbete att bygga \u2013 och d\u00e4rmed dyrare i insats.',
                'N\u00e5got h\u00f6gre l\u00f6pande kostnader eftersom en databas ing\u00e5r.',
                'Fler r\u00f6rliga delar: driften kr\u00e4ver regelbunden sk\u00f6tsel (det sk\u00f6ter jag).',
                'Kr\u00e4ver en Node\u2011server \u2013 vilket f\u00e5 webbhotell erbjuder. Ligger webbplatsen hos mig \u00e4r det inget problem: min server har allt som beh\u00f6vs.'
              ]
            }
          ]
        },
        {
          heading: 'HTMX & PHP',
          description: [
            'Ett medvetet enkelt angreppss\u00e4tt: sidorna skapas p\u00e5 servern och levereras direkt. Lite teknik som kan g\u00e5 s\u00f6nder.'
          ],
          groups: [
            {
              title: 'F\u00f6rdelar',
              items: [
                'Mycket robust och l\u00e5nglivad \u2013 f\u00e5 beroenden, lite underh\u00e5ll.',
                'Billigare att bygga och driva; fungerar p\u00e5 vilket enkelt webbhotell som helst.',
                'Snabba laddtider eftersom n\u00e4stan ingen kod k\u00f6rs i webbl\u00e4saren.',
                'Formul\u00e4r och e\u2011postutskick \u00e4r inbyggda utan omv\u00e4gar.'
              ]
            },
            {
              title: 'Nackdelar',
              items: [
                'Mindre l\u00e4mpad f\u00f6r mycket interaktiva till\u00e4mpningar (t.ex. anv\u00e4ndarkonton eller livekartor).',
                'Inneh\u00e5lls\u00e4ndringar g\u00e5r vanligtvis via mig, inte via ett eget gr\u00e4nssnitt.'
              ]
            }
          ]
        }
      ],
      recommendation: {
        title: 'Vad jag rekommenderar',
        items: [
          { label: 'Next.js & Supabase', text: 'om webbplatsen ska kunna mer \u00e4n informera \u2013 till exempel anv\u00e4ndarkonton, s\u00f6k, kartor eller l\u00f6pande nytt inneh\u00e5ll.' },
          { label: 'HTMX & PHP', text: 'om omfattningen \u00e4r \u00f6versk\u00e5dlig, inneh\u00e5llet s\u00e4llan \u00e4ndras och du v\u00e4rdes\u00e4tter l\u00e5ga driftkostnader.' },
          { label: '', text: 'Du beh\u00f6ver inte avg\u00f6ra det sj\u00e4lv: i det f\u00f6rsta samtalet tittar vi p\u00e5 ditt projekt \u2013 och jag s\u00e4ger \u00e4rligt vilken v\u00e4g som passar.' }
        ]
      }
    },
    services: {
      title: 'Vad Jag Erbjuder',
      websites: {
        title: '1. Små, Snabba och Okomplicerade Webbplatser',
        description: 'Jag fokuserar på smidiga webbpresentationer som fungerar utan ballast och är lätta att underhålla – idealiska för:',
        items: [
          'Egenföretagare och frilansare',
          'Små företag',
          'Föreningar, initiativ och projekt'
        ],
        tech: 'Tekniskt använder jag främst React eller andra moderna ramverk. Denna teknik fascinerar mig eftersom den möjliggör snabba, flexibla och hållbara lösningar.'
      },
      contao: {
        title: '2. Webbplatser med flexibel innehållshantering (Strapi CMS)',
        description: 'För webbplatser som ska uppdateras regelbundet använder jag Strapi som innehållshanteringssystem – en modern, användarvänlig lösning som ger dig full kontroll över ditt innehåll:',
        items: [
          'Intuitiv användning: Texter, bilder och annat innehåll kan redigeras utan teknisk kunskap',
          'Maximal flexibilitet: Systemet anpassar sig till dina krav, inte tvärtom',
          'Framtidssäkert: Strapi är öppen källkod, väl dokumenterad och aktivt vidareutvecklad'
        ],
        tech: 'Kombinationen av React i frontend och Strapi i backend ger en slimmad, högpresterande lösning där du förblir oberoende och kan sköta din webbplats själv när som helst – utan att vara beroende av mig.'
      },
      content: {
        title: '3. Texter, Grafik och Kartor',
        intro: 'Inom alla mina expertområden har jag gedigen kunskap och kan erbjuda dig:',
        introLinkText: 'Inom alla mina expertområden',
        items: [
          'noggrant researchade, lättlästa texter baserade på egen forskning och erfarenhet',
          'illustrativa grafiker, diagram och kartor som gör komplexa samband begripliga'
        ],
        note: 'Särskilt för ämnen som historia, geografi, demografi, ekologiskt jordbruk eller regional utveckling är det viktigt för mig att presentera innehåll korrekt, differentierat och ändå tillgängligt.'
      },
      documentaries: {
        title: '4. Dokumentärer från A till Ö',
        description: 'En annan specialitet är produktion av dokumentärer. På begäran tar jag över hela kedjan:',
        items: [
          'Ämnesval och research',
          'Manus och struktur',
          'Skapande av grafik och bilder',
          'Skapande av musikelement (intro, outro, bakgrundsmusik, låtar)',
          'Redigering med DaVinci Resolve'
        ],
        result: 'På så sätt blir en idé till en sammanhängande, lättbegriplig dokumentär – visuellt och innehållsmässigt konsekvent.'
      }
    },
    process: {
      title: 'Så här fungerar det',
      step1: {
        title: 'Första mötet',
        description: 'Vi diskuterar dina mål, innehåll och särskilda funktioner för ditt företag.'
      },
      step2: {
        title: 'Koncept & Design',
        description: 'Jag utvecklar struktur, layout och anpassade förfrågningsformulär.'
      },
      step3: {
        title: 'Implementering & Lansering',
        description: 'Teknisk implementering, domänuppsättning och hosting – allt från en källa.'
      },
      step4: {
        title: 'Löpande Support',
        description: 'Mindre ändringar via e-post. Jag implementerar dem snabbt.'
      }
    },
    pricing: {
      title: 'Rättvisa, transparenta priser',
      description: 'Inga dolda kostnader. Mindre ändringar ingår i det årliga supportpaketet.',
      included: 'Ingår i supportpaket:',
      items: [
        'Justera texter',
        'Ändra öppettider',
        'Byta bilder',
        'Små innehållstillägg'
      ]
    },
    example: {
      title: 'Till exempel',
      subtitle: 'En webbplats av denna sidans omfattning',
      features: [
        '5 sidor inklusive imprint och integritetspolicy',
        'Omfattande kontaktformulär',
        'AI-genererade bilder för herosektionen',
        'Dynamisk karta för plats',
        'Tre språk',
        'GitHub-repository med all källkod'
      ],
      servicePackage: 'Webbplats inklusive servicepaket för ett år (.de-domän, webbspace, mindre ändringar och tillägg)',
      priceOneYear: '700 Euro plus moms',
      servicePackageThreeYears: 'inklusive servicepaket för tre år:',
      priceThreeYears: '800 Euro plus moms'
    },
    included: {
      title: 'Vad som är standard med varje webbplats',
      items: [
        {
          title: 'SSL-kryptering & HTTPS',
          description: 'Säker anslutning med giltigt certifikat, automatisk omdirigering till https.'
        },
        {
          title: 'GDPR-kompatibel grundkonfiguration',
          description: 'Sekretessanpassade standardinställningar för formulär, loggar och integreringar.'
        },
        {
          title: 'Juridiska bassidor (teknisk implementering)',
          description: 'Integration av imprint & integritetspolicy på rätt platser (t.ex. footer).'
        },
        {
          title: 'Cookie-/samtyckelösning (vid behov)',
          description: 'Inställning av en samtyckesbank för cookies, spårning och externa tjänster.'
        },
        {
          title: 'Sekretessanpassad integration av externa tjänster',
          description: 'T.ex. YouTube/Kartor endast efter samtycke, 2-klicks-lösningar, minimal spårning.'
        },
        {
          title: 'Lokalt hostade webbfonter (inga Google Fonts-fjärranrop)',
          description: 'Typsnitt tillhandahålls på din egen server, inte laddade från tredje part.'
        },
        {
          title: 'Säker bakgrund & användarhantering',
          description: 'Skyddade inloggningar, vettiga rollrättigheter i CMS, aktuella säkerhetsupdateringar.'
        },
        {
          title: 'Automatiserade säkerhetskopieringar',
          description: 'Regelbundna säkerhetskopieringar av filer och databas med definierad återställningsplan.'
        },
        {
          title: 'Mobiloptimerad, snabb frontend',
          description: 'Responsiv design, bildoptimering, caching och ren teknisk SEO-grund.'
        },
        {
          title: 'Dokumentation av viktiga tekniska och sekretessinställningar',
          description: 'Översikt över vilka tjänster som är integrerade – som grund för din advokat/dataskyddsombud.'
        },
        {
          title: 'Komplett GitHub-lagringsplats',
          description: 'Koden för din webbplats är din egendom. Om du vill kan någon annan när som helst ta över underhållet av din webbplats.'
        }
      ]
    },
    target: {
      title: 'Min HTMX-webbplats är därför vanligtvis idealisk för',
      description: 'små företag som sällan har ändringar och inte vill hantera teknik:',
      items: [
        'Hantverksföretag',
        'Läkar- och tandläkarmottagningar',
        'Advokater och skatterådgivare',
        'Solo-entreprenörer',
        'Lokala tjänsteleverantörer',
        'Återförsäljare'
      ]
    },
    contact: {
      title: 'Intresserad?',
      description: 'Låt oss prata om ditt webbplatsprojekt.',
      email: 'Skicka e-post'
    },
    footer: {
      copyright: '© 2026 alitero.eu – Alla rättigheter förbehållna',
      privacy: 'Integritet',
      imprint: 'Avtryck',
      terms: 'Villkor'
    },
    terms: {
      title: 'Allmänna Villkor',
      introduction: 'Dessa allmänna villkor reglerar samarbetet mellan Alitero (Sören Padel) och kunden.',
      sections: {
        scope: {
          title: '1. Tillämpningsområde',
          content: 'Dessa villkor gäller för alla tjänster inom webbutveckling, innehållsskapande och dokumentärproduktion. Avvikande villkor kräver skriftlig överenskommelse.'
        },
        services: {
          title: '2. Tjänster',
          content: 'Omfattningen av tjänsterna avtalas individuellt. Alitero tillhandahåller tjänster efter bästa förmåga och enligt tekniska regler.'
        },
        contract: {
          title: '3. Avtalsslutande',
          content: 'Avtalet sluts genom kundens accept av offerten. Offerter är föremål för ändring och icke-bindande om inte uttryckligen avtalat annorlunda.'
        },
        payment: {
          title: '4. Betalning och Betalningsvillkor',
          content: 'Betalning sker baserat på insats eller fast pris enligt offerten. Fakturor förfaller till betalning inom 14 dagar efter mottagande utan avdrag.'
        },
        liability: {
          title: '5. Ansvar',
          content: 'Alitero ansvarar endast för uppsåt och grov vårdslöshet. Ansvar för ringa vårdslöshet är uteslutet i den utsträckning det är rättsligt tillåtet.'
        },
        rights: {
          title: '6. Upphovsrätt',
          content: 'Den fullständiga källkoden för utvecklade webbplatser överförs till kunden vid full betalning. Kunden erhåller en obegränsad användningsrätt.'
        },
        termination: {
          title: '7. Uppsägning',
          content: 'Båda parter kan säga upp pågående projekt med 14 dagars uppsägning. Redan utförda tjänster ska kompenseras proportionellt.'
        },
        law: {
          title: '8. Tillämplig Lag',
          content: 'Svensk lag tillämpas. Jurisdiktion är, i den utsträckning det är rättsligt tillåtet, Aliteros säte i Sverige.'
        }
      }
    },
    currentPage: {
      heroTitle: 'GeoAtrium',
      heroSubtitle: 'Upptäck Världen',
      heroDescription: 'Hitta de bästa platserna och dela dina upptäckter',
      sectionTitle: 'GeoAtrium: Digital medborgarkarta för små och medelstora företag, myndigheter, föreningar och privatpersoner',
      visitLink: 'Besök webbplatsen',
      mapTitle: 'Interaktiv karta'
    },
    references: {
      heroLabel: 'Portfolio',
      heroTitle: 'Referenser & Videor',
      heroDescription: 'Utvalda projekt och inblickar i mitt arbete',
      websitesTitle: 'Webbprojekt',
      websitesSubtitle: 'Webbplatser jag har utvecklat för kunder och egna projekt',
      videosTitle: 'Videor IT',
      videosSubtitle: 'Inblickar, handledningar och projektpresentationer på YouTube',
      visitWebsite: 'Besök webbplats',
      watchVideos: 'Se videor',
      websites: {
        svansele: 'Ekologisk produktion – egen förädling – direktförsäljning: Svansele Grönt i norra Sverige.',
        geoimage: 'Digital medborgarkarta för turism och förvaltning i EU.',
        norsjo: 'Lokal GeoAtrium-instans för Norsjö kommun i Sverige.',
        hrLanding: 'Modern landningssida för HR- och rekryteringstjänster.',
        demografie: 'Förstå befolkningsutvecklingen',
        geschichteInKarten: 'Videor om historiska ämnen med starkt fokus på kartor',
        schwedenPraktisch: 'Bortom Bullerbyn – hur det verkliga Sverige fungerar i det verkliga livet, utan älgar och semesterromantik',
        liedzeit: 'Bra musik och bra texter, utan genredogmatism',
        nybyggare: 'Vi tror att det är dags att återuppliva den småbrukartradition i norra Sverige. Och precis som förr borde även idag nybyggare från andra regioner hjälpa till att klara av detta',
      },
      videos: {
        video1Title: 'Projektpresentation',
        video1Desc: 'Överblick över aktuella webbprojekt och teknologier.',
        video2Title: 'Tekniska inblickar',
        video2Desc: 'Bakom kulisserna: utvecklingsprocess och verktyg.',
        video3Title: 'Demo & genomgång',
        video3Desc: 'Livedemo av en projektutveckling från början till slut.',
        video4Title: 'HTMX och PHP – en oslagbar kombination?',
        video4Desc: 'Många företag står inför stackvalet: populära Next.js med React och ett stort ekosystem kontra den pragmatiska mixen av HTMX, Tailwind och PHP. Det avgörande är inte "coolhet" utan driftkostnader, underhållbarhet och verklig drift.',
      },
    },
    cookieBanner: {
      title: 'Cookie-meddelande',
      message: 'Denna webbplats använder Umami Analytics för anonym användningsanalys utan personuppgifter. Inga spårningscookies sätts. Genom att fortsätta använda webbplatsen samtycker du till anonym analys.',
      accept: 'Jag förstår',
      privacy: 'Integritet'
    },
    privacyPolicy: {
      title: 'Integritetspolicy',
      lastUpdated: 'Senast uppdaterad',
      introduction: 'Vi tar skyddet av dina data mycket på allvar. Den här integritetsmeddelandet förklarar hur vi bearbetar dina personuppgifter.',
      sections: {
        responsible: {
          title: '1. Ansvarig Part',
          content: 'Den ansvariga för behandling av personuppgifter enligt GDPR är: Sören Padel, Örträsk 48. 935 93 Norsjö, Sverige, info@alitero.eu, +49 157 3004 1651.'
        },
        dataCollection: {
          title: '2. Insamling och Behandling av Data',
          intro: 'Vi samlar in och behandlar personuppgifter endast när det är juridiskt tillåtet och för ett specifikt syfte. Data behandlas enligt följande:',
          contact: 'Kontaktformulär: När du använder vårt kontaktformulär samlar vi in ditt namn, e-postadress och annan information du tillhandahåller. Denna data används endast för att svara på din förfrågan.',
          analytics: 'Webbplatsanalys: Vi använder inte tredjepartsverktyg som skickar din data till externa servrar.'
        },
        purposes: {
          title: '3. Ändamål för Databehandling',
          intro: 'Dina uppgifter behandlas för följande ändamål:',
          items: [
            'Besvara förfrågningar via kontaktformulär',
            'Kommunikation med dig angående planerade eller genomförda webbplatsprojekt',
            'Efterlevnad av juridiska skyldigheter (t.ex. arkivering av affärshandlingar)'
          ]
        },
        legalBasis: {
          title: '4. Rättslig Grund',
          content: '**Rättslig grund för behandling av personuppgifter**\n\nBehandlingen av dina personuppgifter sker i enlighet med artikel 6.1 i EU:s allmänna dataskyddsförordning (GDPR) samt svensk dataskyddslag (2018:218). Vi behandlar dina personuppgifter baserat på följande rättsliga grunder:\n\n**Fullgörande av avtal (artikel 6.1 b GDPR):** Vi behandlar dina personuppgifter när det är nödvändigt för att fullgöra ett avtal med dig eller för att vidta åtgärder på din begäran innan ett avtal ingås.\n\n**Samtycke (artikel 6.1 a GDPR):** I vissa fall behandlar vi dina personuppgifter efter att du har lämnat ditt uttryckliga samtycke. Du har alltid rätt att när som helst återkalla ditt samtycke.\n\n**Berättigat intresse (artikel 6.1 f GDPR):** Vi kan behandla dina personuppgifter när det är nödvändigt för våra berättigade intressen, såvida inte dina intressen eller grundläggande rättigheter och friheter väger tyngre. Sådana berättigade intressen kan omfatta förbättring av våra tjänster, säkerhet och marknadsföring.\n\n**Rättslig förpliktelse (artikel 6.1 c GDPR):** Vi behandlar dina personuppgifter när vi är skyldiga att göra det enligt lag, till exempel för bokföringsändamål.'
        },
        dataSharing: {
          title: '5. Delning med Tredje Parter',
          content: 'Vi delar inte dina personuppgifter med tredje parter om det inte är juridiskt obligatoriskt (t.ex. för juridiska skyldigheter) eller du har uttryckligen samtyckt. Dina uppgifter delas inte med tredje parter för marknadsföring.'
        },
        storage: {
          title: '6. Lagringsperiod',
          content: 'Dina personuppgifter lagras endast så länge som nödvändigt för att uppfylla de angivna syften. Efter projektets avslutande eller avslag av en förfrågan raderas dina data senast efter 3 år, om inte längre lagringsperioder krävs enligt lag (t.ex. för affärshandlingar).'
        },
        rights: {
          title: '7. Dina Rättigheter',
          intro: 'Du har följande rättigheter angående dina personuppgifter (Artikel 15-22 GDPR):',
          items: [
            'Rätt till Information: Du kan begära information om dina personuppgifter när som helst.',
            'Rätt till Rättelse: Du kan få felaktig data korrigerad.',
            'Rätt till Radering: Du kan under vissa förutsättningar begära radering av dina uppgifter.',
            'Rätt till Begränsning: Du kan begära att behandling av dina uppgifter begränsas.',
            'Rätt till Dataportabilitet: Du kan få dina uppgifter i ett strukturerat, vanligt och maskinläsbart format.',
            'Rätt att Invända: Du kan invända mot behandling av dina uppgifter.'
          ]
        },
        contact: {
          title: '8. Kontakt för Integritetsfrågor',
          content: 'Om du vill utöva dina rättigheter eller har frågor om dataskydd kontaktar du oss på: [E-post], [Telefon].'
        },
        cookies: {
          title: '9. Cookies och Liknande Teknologier',
          content: 'Denna webbplats använder inte personliga spårningscookies. För att förbättra våra tjänster använder vi Umami Analytics, ett integritetsvänligt analysverktyg som samlar in besöksdata på ett helt anonymiserat sätt. Inga IP-adresser lagras och inga personuppgifter samlas in. Analysen tjänar endast statistiska syften.'
        },
        security: {
          title: '10. Datasäkerhet',
          content: 'Vi implementerar tekniska och organisatoriska åtgärder för att skydda dina uppgifter från missbruk, förlust och obehörig åtkomst. All överföring sker via säkra HTTPS-anslutningar. Vi kan dock inte garantera absolut säkerhet.'
        },
        thirdParties: {
          title: '11. Externa Tjänster',
          intro: 'Den här webbplatsen använder följande externa tjänster:',
          umami: 'Umami Analytics: För anonym användningsanalys. Inga personuppgifter samlas in. Mer information: https://umami.is/docs/privacy',
          staticforms: 'Formulärbehandling: Dina förfrågningar behandlas uteslutande på vår egen server i Tyskland (självhostad Supabase) och vidarebefordras till oss via e-post. Inga uppgifter lämnas ut till tredjepartsleverantörer.'
        },
        changes: {
          title: '12. Ändringar av denna Integritetspolicy',
          content: 'Vi förbehåller oss rätten att ändra denna integritetspolicy när som helst. Ändringar publiceras på denna sida. Vänligen granska den regelbundet.'
        }
      }
    },
    requestForm: {
      title: 'Begär Offert',
      subtitle: 'Berätta om ditt projekt. Fyll i detta formulär så att jag kan få en första uppfattning.',
      wizard: {
        step: 'Steg',
        of: 'av',
        next: 'Nästa',
        back: 'Tillbaka',
        review: 'Sammanfattning',
        reviewHint: 'Kontrollera dina uppgifter innan du skickar förfrågan.',
        notSpecified: 'Ej angivet',
        stepNames: {
          1: 'Kontakt & Företag',
          2: 'Webbplats & Omfattning',
          3: 'Budget & Samarbete',
          4: 'Granska & Skicka'
        },
        errors: {
          name: 'Ange ditt namn.',
          email: 'Ange en giltig e-postadress.'
        }
      },
      sections: {
        contact: 'Dina Kontaktuppgifter',
        company: 'Ditt Företag',
        website: 'Nuvarande Webbplatsstatus',
        scope: 'Omfattning & Innehåll',
        details: 'Projektdetaljer',
        budget: 'Budget & Tidsram',
        cooperation: 'Samarbete'
      },
      fields: {
        name: 'Namn',
        email: 'E-postadress',
        phone: 'Telefonnummer (frivilligt)',
        company: 'Företag / Organisation (frivilligt)',
        industry: 'Bransch / Verksamhetsområde',
        location: 'Plats (Ort / Land)',
        websiteLink: 'Länk till befintlig webbplats',
        goals: 'Vad ska din webbplats göra för dig?',
        notes: 'Finns det något som är särskilt viktigt för dig i samarbetet?',
        otherLanguage: 'Annat språk',
        otherScope: 'Övrigt / Särskilda krav'
      },
      options: {
        status: {
          none: 'Vi har ingen webbplats än.',
          new: 'Vi har en webbplats, men vill ha en ny.',
          relaunch: 'Vår webbplats behöver omarbetas.'
        },
        scope: {
          home: 'Startsida / Översikt',
          services: 'Tjänster / Erbjudande',
          about: 'Om oss / Team',
          contact: 'Kontaktsida',
          forms: 'Anpassade förfrågningsformulär',
          blog: 'Blogg / Nyheter',
          multi: 'Flerspråkighet',
          other: 'Övrigt / Särskilda krav'
        },
        languages: {
          de: 'Tyska',
          en: 'Engelska',
          sv: 'Svenska',
          hu: 'Ungerska',
          other: 'Annat'
        },
        budget: {
          label: 'Budgetuppskattning (icke-bindande)',
          unknown: 'Jag har ingen uppfattning än',
          small: 'Mindre ram (enkel, kompakt webbplats)',
          medium: 'Mellanstor ram (flera undersidor)',
          large: 'Större ram (särskilda krav)'
        },
        timeline: {
          label: 'Tidsram',
          asap: 'Så snart som möjligt',
          months: 'Inom de närmaste 1–3 månaderna',
          later: 'Senare, jag samlar bara information'
        },
        support: {
          maintenance: 'Jag önskar löpande support (inkl. ändringar).',
          hosting: 'Domän och hosting ska ordnas.'
        }
      },
      privacy: {
        text: 'Genom att skicka formuläret godkänner du att jag behandlar dina uppgifter för att hantera din förfrågan.',
        checkbox: 'Ja, jag har läst integritetspolicyn och godkänner.'
      },
      submit: 'Skicka Icke-bindande Förfrågan',
      success: 'Tack för din förfrågan! Jag återkommer till dig inom kort.',
      errorSend: 'Förfrågan kunde inte skickas. Försök igen senare eller mejla info@alitero.eu.',
      errorRateLimited: 'För många förfrågningar. Försök igen senare eller mejla info@alitero.eu.',
      errorDisposable: 'Använd en permanent e‑postadress – vi kan inte svara på engangsadresser.',
      errorStale: 'Formuläret var öppet för länge. Ladda om sidan och skicka igen.'
    },
    imprint: {
      title: 'Meddelande',
      lastUpdated: 'Senast uppdaterad',
      introduction: 'Information enligt lag',
      sections: {
        responsible: {
          title: 'Ansvarig för innehål',
          name: 'Sören Padel',
          address: 'Örträsk 48, 935 93 Norsjö, Sverige',
          email: 'E-post: info@alitero.eu',
          phone: 'Telefon: +49 157 3004 1651'
        },
        eu: {
          title: 'EU-tvistlösning',
          content: 'Europeiska kommissionen tillhandahåller en plattform för onlinetvistlösning (ODR). Du kan hitta denna plattform på https://ec.europa.eu/consumers/odr/'
        },
        liability: {
          title: 'Ansvarsfriskrivning',
          intro: 'Trots noggrann och grundlig innehållskontroll accepterar vi inget ansvar för innehållet i externa länkar. Operatörerna av de länkade sidorna är ensamt ansvariga för sitt innehål.',
          accuracy: 'Innehållet på denna webbplats skapas noggrant och samvetsgrann och uppdateras regelbundet. Vi kan dock inte garantera aktualitet, noggrannhet och fullständighet av allt innehål.',
          liability_clause: 'Skaderegresser mot författaren, som avser skada av materiell eller immateriell slag orsakad av användning eller icke-användning av den presenterade informationen eller genom användning av felaktig och ofullständig information, är i princip uteslutna.'
        },
        copyright: {
          title: 'Upphovsrätt',
          content: 'Innehållet publicerat på denna webbplats är skyddat av upphovsrätt. All användning som inte tillåts enligt upphovsrätten kräver föregående uttrycklig samtycke från författaren eller rättighetsinnehavaren. Detta gäller särskilt kopiering, redigering, översättning, lagring, behandling i elektroniska system och distribution.'
        },
        dataprivacy: {
          title: 'Dataskydd',
          content: 'Vi tar skyddet av dina personuppgifter på allvar. Information om vår integritetspolicy finns i avsnittet "Integritet".'
        },
        disclaimer: {
          title: 'Ansvarsfriskrivning för innehål',
          content: 'Som tjänstleverantör är vi ansvariga för vårt eget innehål på dessa sidor enligt allmän lag. Vi är dock inte skyldiga att övervaka överförd eller lagrad information från tredje part eller att undersöka omständigheter som indikerar olaglig verksamhet.'
        }
      }
    },
    about: {
      title: 'Om Mig – Sören Padel / Alitero',
      greeting: 'Hej,',
      intro: 'jag heter Sören Padel. Alitero är en latinbaserad neologism som beskriver någon som medvetet närmar sig saker lite annorlunda.',
      aliteroMeaning: 'Det är precis min approach: lösningar som inte är från hyllan, utan passar dig och ditt projekt.',
      background: {
        title: 'Yrkesmässig Bakgrund',
        intro: 'Jag har utvecklat webbplatser i cirka 25 år – först av personligt intresse och för egna projekt, nu även professionellt för kunder. Egentligen är jag:',
        roles: [
          'Historiker',
          'IT-kunnig geograf – och därmed även kartograf och demograf',
          'Pedagog och Sverigeexpert',
          'med mångårig erfarenhet av ekologiskt jordbruk och regional utveckling'
        ],
        summary: 'Denna blandning av humaniora och rumsvetenskap, praktik inom jordbruk och regional utveckling samt pedagogisk erfarenhet är grunden för mitt arbete: Jag kan forska, strukturera, förklara tydligt och förbereda innehåll så att det blir greppbart för dina målgrupper.'
      },
      services: {
        title: 'Vad Jag Erbjuder',
        websites: {
          title: '1. Små, Snabba och Okomplicerade Webbplatser',
          description: 'Jag fokuserar på smidiga webbpresentationer som fungerar utan ballast och är lätta att underhålla – idealiska för:',
          items: [
            'Egenföretagare och frilansare',
            'Små företag',
            'Föreningar, initiativ och projekt'
          ],
          tech: 'Tekniskt använder jag främst React eller andra moderna ramverk. Denna teknik fascinerar mig eftersom den möjliggör snabba, flexibla och hållbara lösningar.'
        },
        contao: {
          title: '2. Webbplatser med flexibel innehållshantering (Strapi CMS)',
          description: 'För webbplatser som ska uppdateras regelbundet använder jag Strapi som innehållshanteringssystem – en modern, användarvänlig lösning som ger dig full kontroll över ditt innehåll:',
          items: [
            'Intuitiv användning: Texter, bilder och annat innehåll kan redigeras utan teknisk kunskap',
            'Maximal flexibilitet: Systemet anpassar sig till dina krav, inte tvärtom',
            'Framtidssäkert: Strapi är öppen källkod, väl dokumenterad och aktivt vidareutvecklad'
          ],
          tech: 'Kombinationen av React i frontend och Strapi i backend ger en slimmad, högpresterande lösning där du förblir oberoende och kan sköta din webbplats själv när som helst – utan att vara beroende av mig.'
        },
        content: {
          title: '3. Texter, Grafik och Kartor',
          intro: 'Inom alla mina expertområden har jag gedigen kunskap och kan erbjuda dig:',
          items: [
            'noggrant researchade, lättlästa texter baserade på egen forskning och erfarenhet',
            'illustrativa grafiker, diagram och kartor som gör komplexa samband begripliga'
          ],
          note: 'Särskilt för ämnen som historia, geografi, demografi, ekologiskt jordbruk eller regional utveckling är det viktigt för mig att presentera innehåll korrekt, differentierat och ändå tillgängligt.'
        },
        documentaries: {
          title: '4. Dokumentärer från A till Ö',
          description: 'En annan specialitet är produktion av dokumentärer. På begäran tar jag över hela kedjan:',
          items: [
            'Ämnesval och research',
            'Manus och struktur',
            'Skapande av grafik och bilder',
            'Redigering med DaVinci Resolve'
          ],
          result: 'På så sätt blir en idé till en sammanhängande, lättbegriplig dokumentär – visuellt och innehållsmässigt konsekvent.'
        }
      },
      tools: {
        title: 'De program jag helst arbetar med',
        intro: 'I min verktygslåda finns bland annat:',
        items: [
          { category: 'Utveckling', tool: 'VSCodium' },
          { category: 'Data', tool: 'RStudio' },
          { category: 'Kartor & GIS', tool: 'QGIS, OpenLayers' },
          { category: 'Media', tool: 'Affinity Suite, Fooocus, DaVinci Resolve Studio, Audacity, OBS Studio' },
          { category: 'Vetenskapligt arbete', tool: 'TeXstudio, Zotero' },
          { category: 'Samarbete & Fillagring', tool: 'Nextcloud' }
        ],
        conclusion: 'Min arbetsmiljö är medvetet tvärvetenskaplig. Där det passar använder jag öppen källkod – inte för dess egen skull, utan för att minska beroenden och hålla projekt underhållbara på lång sikt.'
      },
      personal: {
        title: 'Vem Jag Är Utanför Skärmen',
        intro: 'På min fritid är jag:',
        hobbies: [
          'Biodlare',
          'Tjänstehundssportare',
          'Hobbybryggare'
        ],
        conclusion: 'Dessa aktiviteter har en sak gemensamt: De kräver tålamod, precision, ansvar och överblick. Denna inställning präglar också mitt arbete med webbplatser, texter, grafik och dokumentärer.'
      },
      cta: {
        welcome: 'Välkommen till Alitero.',
        message: 'Om du söker en webbplats, texter eller en dokumentär som är professionellt gedigen, begriplig och genomförd med kärlek till detaljer, ser jag fram emot ditt meddelande.',
        signature: 'Din Sören Padel',
        button: 'Kontakta mig'
      }
    }
  },
  hu: {
    nav: {
      home: 'Főoldal',
      services: 'Szolgáltatások',
      request: 'Ajánlatkérés',
      about: 'Rólam',
      current: 'Aktuális',
      references: 'Referenciák'
    },
    hero: {
      title: 'Modern Weboldalak Kisvállalkozásoknak',
      subtitle: 'Karcsú, gyors és professzionális – bonyolult technológia nélkül',
      description: 'Világos, reszponzív weboldalakat készítek kézműveseknek, praxisoknak és kisvállalkozásoknak. Nincs CMS-káosz, nincsenek rejtett költségek – mindenről én gondoskodom.',
      cta: 'Kapcsolatfelvétel'
    },
    features: {
      title: 'Miért más a megközelítésem',
      nocms: {
        title: 'Nincs CMS-stressz',
        description: 'Nem kell bonyolult rendszert megtanulnia. A változtatásokat én végzem el – csak kérje e-mailben.'
      },
      responsive: {
        title: '100% Reszponzív',
        description: 'Weboldala tökéletesen néz ki okostelefonon, tableten és asztali gépen. Mobil navigáció érintőképernyős használatra optimalizálva.'
      },
      hosting: {
        title: 'EU Hosting',
        description: 'Átlátható árak, GDPR megfelelő, szerverek Európában. Nincsenek rejtett felhő költségek tengerentúlról.'
      },
      ownership: {
        title: 'A Kód az Öné',
        description: 'Teljes forráskód Git tárolóban. Nincs függőség – bármely fejlesztő átveheti.'
      }
    },
    comparison: {
      title: 'Melyik \u00fat illik az \u00d6n tervéhez?',
      sections: [
        {
          heading: 'Next.js & Supabase',
          description: [
            'Modern webalkalmaz\u00e1s saj\u00e1t adatb\u00e1zissal. Az oldal azonnal reag\u00e1l \u2013 an\u00e9lk\u00fcl, hogy minden kattint\u00e1sra \u00faj oldal t\u00f6lt\u0151dne be.'
          ],
          groups: [
            {
              title: 'El\u0151ny\u00f6k',
              items: [
                'Ide\u00e1lis mindenhez, ami t\u00fal mutat egy n\u00e9vjegyk\u00e1rty\u00e1n: felhaszn\u00e1l\u00f3i fi\u00f3kok, keres\u00e9s, t\u00e9rk\u00e9pek, foglal\u00e1sok.',
                'A tartalom k\u00e9nyelmesen kezelhet\u0151 saj\u00e1t fel\u00fcleten \u2013 programoz\u00e1si tud\u00e1s n\u00e9lk\u00fcl.',
                'Nagyon gyors haszn\u00e1lat: az oldal \u00fagy m\u0171k\u00f6dik, mint egy alkalmaz\u00e1s.',
                'Egy\u00fctt n\u0151 \u00d6nnel \u2013 k\u00e9s\u0151bb \u00faj funkci\u00f3k adhat\u00f3k hozz\u00e1.'
              ]
            },
            {
              title: 'H\u00e1tr\u00e1nyok',
              items: [
                'Munkaig\u00e9nyesebb fejleszt\u00e9s \u2013 \u00edgy dr\u00e1g\u00e1bb a bekerül\u00e9si k\u00f6lts\u00e9g.',
                'Kiss\u00e9 magasabb \u00fczemeltet\u00e9si k\u00f6lts\u00e9g, mert adatb\u00e1zis is fut.',
                'T\u00f6bb mozg\u00f3 alkatr\u00e9sz: az \u00fczemeltet\u00e9s rendszeres karbantart\u00e1st ig\u00e9nyel (ezt \u00e9n v\u00e9gzem).',
                'Node\u2011szervert ig\u00e9nyel \u2013 amit a t\u00e1rhelyszolg\u00e1ltat\u00f3k t\u00f6bbs\u00e9ge nem k\u00edn\u00e1l. Ha n\u00e1lam van a weboldala, ez nem gond: a szerverem mindent tud hozz\u00e1.'
              ]
            }
          ]
        },
        {
          heading: 'HTMX & PHP',
          description: [
            'Tudatosan egyszer\u0171 megk\u00f6zel\u00edt\u00e9s: az oldalak a szerveren k\u00e9sz\u00fclnek \u00e9s k\u00f6zvetlen\u00fcl \u00e9rkeznek. Kev\u00e9s technika, ami elromolhat.'
          ],
          groups: [
            {
              title: 'El\u0151ny\u00f6k',
              items: [
                'Nagyon robusztus \u00e9s hossz\u00fa \u00e9let\u0171 \u2013 kev\u00e9s f\u00fcgg\u0151s\u00e9g, kev\u00e9s karbantart\u00e1s.',
                'Olcs\u00f3bb l\u00e9trehozni \u00e9s \u00fczemeltetni; b\u00e1rmelyik egyszer\u0171 t\u00e1rhelyen fut.',
                'Gyors bet\u00f6lt\u00e9s, mert alig fut k\u00f3d a b\u00f6ng\u00e9sz\u0151ben.',
                'Az \u0171rlapok \u00e9s az e\u2011mail k\u00fcld\u00e9s ker\u00fcl\u0151utak n\u00e9lk\u00fcl be\u00e9p\u00edtettek.'
              ]
            },
            {
              title: 'H\u00e1tr\u00e1nyok',
              items: [
                'Kev\u00e9sb\u00e9 alkalmas er\u0151sen interakt\u00edv alkalmaz\u00e1sokhoz (pl. felhaszn\u00e1l\u00f3i fi\u00f3kok vagy \u00e9l\u0151 t\u00e9rk\u00e9pek).',
                'A tartalmi v\u00e1ltoztat\u00e1sok \u00e1ltal\u00e1ban rajtam kereszt\u00fcl t\u00f6rt\u00e9nnek, nem saj\u00e1t fel\u00fcleten.'
              ]
            }
          ]
        }
      ],
      recommendation: {
        title: 'Mit aj\u00e1nlok',
        items: [
          { label: 'Next.js & Supabase', text: 'ha a weboldal t\u00f6bbet tudjon, mint t\u00e1j\u00e9koztatni \u2013 p\u00e9ld\u00e1ul felhaszn\u00e1l\u00f3i fi\u00f3kok, keres\u00e9s, t\u00e9rk\u00e9pek vagy folyamatosan \u00faj tartalmak.' },
          { label: 'HTMX & PHP', text: 'ha a terjedelem \u00e1ttekinthet\u0151, a tartalom ritk\u00e1n v\u00e1ltozik, \u00e9s fontosak az alacsony \u00fczemeltet\u00e9si k\u00f6lts\u00e9gek.' },
          { label: '', text: 'Nem kell egyed\u00fcl d\u00f6ntenie: az els\u0151 besz\u00e9lget\u00e9sen \u00e1tn\u00e9zz\u00fck a terv\u00e9t \u2013 \u00e9s \u0151szint\u00e9n megmondom, melyik \u00fat illik hozz\u00e1.' }
        ]
      }
    },
    services: {
      title: 'Mit Kínálok',
      websites: {
        title: '1. Kis, Gyors és Egyszerű Weboldalak',
        description: 'Karcsú webprezentációkra koncentrálok, amelyek ballaszt nélkül működnek és könnyen karbantarthatók – ideálisak:',
        items: [
          'Egyéni vállalkozóknak és szabadúszóknak',
          'Kisvállalkozásoknak',
          'Egyesületeknek, kezdeményezéseknek és projekteknek'
        ],
        tech: 'Technikailag főleg Reactot vagy más modern keretrendszereket használok. Ez a technológia lelkesít, mert gyors, rugalmas és tartós megoldásokat tesz lehetővé.'
      },
      contao: {
        title: '2. Weboldalak rugalmas tartalomkezeléssel (Strapi CMS)',
        description: 'Azon weboldalakhoz, amelyeket rendszeresen frissíteni kell, a Strapi tartalomkezelő rendszerre támaszkodom – egy modern, felhasználóbarát megoldásra, amely teljes ellenőrzést biztosít a tartalom felett:',
        items: [
          'Intuitív kezelés: Szövegek, képek és más tartalmak szerkeszthetők műszaki előismeret nélkül',
          'Maximális rugalmasság: A rendszer alkalmazkodik az Ön igényeihez, nem fordítva',
          'Jövőálló: A Strapi nyílt forráskódú, jól dokumentált és aktívan fejlesztett'
        ],
        tech: 'A React frontend és a Strapi backend kombinációja egy karcsú, nagy teljesítményű megoldást eredményez, ahol Ön független marad és bármikor saját maga karbantarthatja weboldalát – anélkül, hogy rám lenne utalva.'
      },
      content: {
        title: '3. Szövegek, Grafikák és Térképek',
        intro: 'Minden szakterületemen alapos tudással rendelkezem, és tudok biztosítani:',
        introLinkText: 'Minden szakterületemen alapos tudással',
        items: [
          'alaposan kutatott, jól olvasható szövegeket, amelyek saját kutatáson és tapasztalaton alapulnak',
          'szemléltető grafikákat, diagramokat és térképeket, amelyek érthetővé teszik a bonyolult összefüggéseket'
        ],
        note: 'Különösen olyan témáknál, mint a történelem, földrajz, demográfia, ökológiai gazdálkodás vagy regionális fejlesztés, fontos számomra, hogy a tartalmat helyesen, differenciáltan és mégis hozzáférhetően mutassam be.'
      },
      documentaries: {
        title: '4. Dokumentumfilmek A-tól Z-ig',
        description: 'Egy másik specialitásom a dokumentumfilmek gyártása. Kérésre átveszem a teljes láncot:',
        items: [
          'Témaválasztás és kutatás',
          'Forgatókönyv és struktúra',
          'Grafikák és képek készítése',
          'Zenei elemek elkészítése (bevezető, lezarás, háttérzenei, dal)',
          'Vágás DaVinci Resolve-val'
        ],
        result: 'Így egy ötletből összefüggő, könnyen érthető dokumentumfilm lesz – vizuálisan és tartalmilag is következetes.'
      }
    },
    process: {
      title: 'Hogyan működik',
      step1: {
        title: 'Első találkozó',
        description: 'Megbeszéljük céljait, tartalmát és vállalkozása különleges jellemzőit.'
      },
      step2: {
        title: 'Koncepció és Design',
        description: 'Kidolgozom a struktúrát, elrendezést és testreszabott érdeklődési űrlapokat.'
      },
      step3: {
        title: 'Megvalósítás és Indítás',
        description: 'Technikai megvalósítás, domain beállítás és hosting – minden egy helyről.'
      },
      step4: {
        title: 'Folyamatos Támogatás',
        description: 'Kisebb változtatások e-mailben. Gyorsan megvalósítom őket.'
      }
    },
    pricing: {
      title: 'Tisztességes, átlátható árak',
      description: 'Nincsenek rejtett költségek. A kisebb változtatások benne vannak az éves támogatási csomagban.',
      included: 'A támogatási csomag tartalmazza:',
      items: [
        'Szövegek módosítása',
        'Nyitvatartás változtatása',
        'Képek cseréje',
        'Kis tartalmi kiegészítések'
      ]
    },
    example: {
      title: 'Például',
      subtitle: 'Egy ilyen oldal terjedelmi weboldalat',
      features: [
        '5 oldal az impresszummal és az adatvédelmi nyilatkozattal',
        'Átfogó kapcsolati űrlap',
        'AI-generált képek a héroszekcióhoz',
        'Dinamikus térkép a helyhez',
        'Három nyelv',
        'GitHub-tárház a teljes forráskóddal'
      ],
      servicePackage: 'Webhely inkluzíve szupportcsomag egy évre (.de domain, webspace, kisebb változtatások és kiegészítések)',
      priceOneYear: '700 Euro plus ÁFA',
      servicePackageThreeYears: 'inkluzíve szupportcsomag három évre:',
      priceThreeYears: '800 Euro plus ÁFA'
    },
    included: {
      title: 'Mit tartalmaz minden weboldal alapértelmezésben',
      items: [
        {
          title: 'SSL-titkosítás és HTTPS',
          description: 'Biztonságos kapcsolat érvényes tanúsítvánnyal, automatikus átirányítás a https-re.'
        },
        {
          title: 'GDPR-megfelelő alapkonfiguráció',
          description: 'Adatvédelmi alapértelmezett beállítások az űrlapokhoz, naplókhoz és integrációkhoz.'
        },
        {
          title: 'Jogi alapoldalak (technikai megvalósítás)',
          description: 'Az impresszum és adatvédelmi nyilatkozat integrálása a megfelelő helyekre (pl. lábléc).'
        },
        {
          title: 'Cookie-/hozzájárulási megoldás (ha szükséges)',
          description: 'Hozzájárulási szalagcsík beállítása sütikhez, nyomon követéshez és külső szolgáltatásokhoz.'
        },
        {
          title: 'Adatvédelmi szempontból megfelelő külső szolgáltatások integrálása',
          description: 'Pl. YouTube/Térképek csak hozzájárulás után, 2 kattintásos megoldások, minimális nyomon követés.'
        },
        {
          title: 'Lokálisan üzemeltetett webtípusok (nincs Google Fonts távoli hívás)',
          description: 'A betűtípusok saját szerverén kerülnek kiszolgálásra, nem harmadik felektől töltődnek be.'
        },
        {
          title: 'Biztonságos háttér és felhasználókezelés',
          description: 'Védett bejelentkezések, értelmes szerepkörök a CMS-ben, aktuális biztonsági frissítések.'
        },
        {
          title: 'Automatizált biztonsági mentések',
          description: 'Rendszeres biztonsági mentés fájlok és adatbázis meghatározott helyreállítási tervvel.'
        },
        {
          title: 'Mobilra optimalizált, gyors kezelőfelület',
          description: 'Reszponzív tervezés, képoptimalizálás, gyorsítótárazás és tiszta technikai SEO alap.'
        },
        {
          title: 'A fontos technikai és adatvédelmi beállítások dokumentációja',
          description: 'Áttekintés az integrált szolgáltatásokról – alapként az ügyvédnek/adatvédelmi tisztségviselőnek.'
        },
        {
          title: 'Teljes GitHub-tárház',
          description: 'Weboldala kódja az Ön tulajdona. Ha szeretné, bárki átveheti weboldala karbantartását bármikor.'
        }
      ]
    },
    target: {
      title: 'Így az HTMX-weboldalam általában ideális',
      description: 'kisvállalkozásoknak, amelyek ritkán változtatnak és nem akarnak technológiával foglalkozni:',
      items: [
        'Kézműves vállalkozások',
        'Orvosi és fogorvosi praxisok',
        'Ügyvédek és adótanácsadók',
        'Egyéni vállalkozók',
        'Helyi szolgáltatók',
        'Kiskereskedők'
      ]
    },
    contact: {
      title: 'Érdeklődik?',
      description: 'Beszéljünk weboldal projektjéről.',
      email: 'E-mail küldése'
    },
    footer: {
      copyright: '© 2026 alitero.eu – Minden jog fenntartva',
      privacy: 'Adatvédelem',
      imprint: 'Impresszum',
      terms: 'ÁSZF'
    },
    terms: {
      title: 'Általános Szerződési Feltételek (ÁSZF)',
      introduction: 'Ezek az általános szerződési feltételek szabályozzák az Alitero (Sören Padel) és az ügyfél közötti együttműködést.',
      sections: {
        scope: {
          title: '1. Alkalmazási Kör',
          content: 'Ezek az ÁSZF minden webfejlesztési, tartalomkészítési és dokumentárfilm-gyártási szolgáltatásra vonatkoznak. Az eltérő feltételek írásbeli megállapodást igényelnek.'
        },
        services: {
          title: '2. Szolgáltatások',
          content: 'A szolgáltatások körét egyedileg állapodják meg. Az Alitero a szolgáltatásokat legjobb tudása szerint és a technológia szabályainak megfelelően nyújtja.'
        },
        contract: {
          title: '3. Szerződéskötés',
          content: 'A szerződés az ajánlat ügyfél általi elfogadásával jön létre. Az ajánlatok változások tárgyát képezik és nem kötelezőek, kivéve ha kifejezetten másként egyeztek meg.'
        },
        payment: {
          title: '4. Fizetés és Fizetési Feltételek',
          content: 'A fizetés ráfordítás vagy fix ár alapján történik, az ajánlatban megegyezettek szerint. A számlák fizetési határideje kézhezvettől számított 14 nap levonás nélkül.'
        },
        liability: {
          title: '5. Felelősség',
          content: 'Az Alitero csak szándékoság és súlyos gondatlanság esetén felel. A könnyű gondatlanságért való felelősség kizárt, amennyiben ez jogilag megengedett.'
        },
        rights: {
          title: '6. Szerzői Jogok',
          content: 'A kifejlesztett weboldalak teljes forráskódja a teljes fizetést követően átkerül az ügyfélhez. Az ügyfél korlátlan használati jogot kap.'
        },
        termination: {
          title: '7. Felmondás',
          content: 'Mindkét fél felmondhatja a folyamatban lévő projekteket 14 napos felmondási idővel. A már nyújtott szolgáltatásokat arányosan kell megfizetni.'
        },
        law: {
          title: '8. Alkalmazandó Jog',
          content: 'Svéd jog alkalmazandó. Joghatóság, amennyiben jogilag megengedett, az Alitero székhelye Svédországban.'
        }
      }
    },
    currentPage: {
      heroTitle: 'GeoAtrium',
      heroSubtitle: 'Fedezd Fel a Világot',
      heroDescription: 'Találd meg a legjobb helyeket és oszd meg felfedezéseidet',
      sectionTitle: 'GeoAtrium: Digitális polgári térkép kkv-k, hatóságok, egyesületek és magánszemélyek számára',
      visitLink: 'Weboldal megtekintése',
      mapTitle: 'Interaktív térkép'
    },
    references: {
      heroLabel: 'Portfólió',
      heroTitle: 'Referenciák & Videók',
      heroDescription: 'Válogatott projektek és betekintés a munkámba',
      websitesTitle: 'Webprojektek',
      websitesSubtitle: 'Weboldalak, amelyeket ügyfeleknek és saját projektekhez fejlesztettem',
      videosTitle: 'Videók IT',
      videosSubtitle: 'Betekintések, oktatóanyagok és projektbemutatók a YouTube-on',
      visitWebsite: 'Weboldal megtekintése',
      watchVideos: 'Videók megtekintése',
      websites: {
        svansele: 'Ökológiai termelés – saját feldolgozás – közvetlen értékesítés: Svansele Grönt Észak-Svédországban.',
        geoimage: 'Digitális polgári térkép turizmushoz és közigazgatáshoz az EU-ban.',
        norsjo: 'Helyi GeoAtrium példány Norsjö községnek Svédországban.',
        hrLanding: 'Modern nyitóoldal HR- és toborzási szolgáltatásokhoz.',
        demografie: 'A népességfejlődés megértése',
        geschichteInKarten: 'Videók történelmi témákról, erős térképes fókusszal',
        schwedenPraktisch: 'Bullerbün túl – hogyan működik az igazi Svédország az igazi életben, jávorszarvas és nyaralós romantika nélkül',
        liedzeit: 'Jó zene és jó szövegek, műfaji dogmatizmus nélkül',
        nybyggare: 'Úgy gondoljuk, ideje feléleszteni az észak-svédországi kisparaszti hagyományt. És mint régen, ma is más régiókból érkező telepeseknek kellene segíteni ebben',
      },
      videos: {
        video1Title: 'Projektbemutató',
        video1Desc: 'Áttekintés az aktuális webprojektekről és technológiákról.',
        video2Title: 'Technikai betekintés',
        video2Desc: 'A kulisszák mögött: fejlesztési folyamat és eszközök.',
        video3Title: 'Demo & áttekintés',
        video3Desc: 'Élő bemutató egy projektfejlesztésről az elejétől a végéig.',
        video4Title: 'HTMX és PHP – verhetetlen kombináció?',
        video4Desc: 'Sok vállalat áll a stack-választás előtt: a népszerű Next.js React-tel és nagy ökoszisztémával, szemben a HTMX, Tailwind és PHP pragmatikus kombinációjával. Nem a „menőség" a döntő, hanem az üzemeltetési költségek, karbantarthatóság és a működési valóság.',
      },
    },
    cookieBanner: {
      title: 'Cookie-értesítés',
      message: 'Ez a weboldal Umami Analytics-t használ névtelen használatelemzéshez személyes adatok nélkül. Nincsenek követő sütik beállítva. Az oldal további használatával hozzájárul a névtelen elemzéshez.',
      accept: 'Értem',
      privacy: 'Adatvédelem'
    },
    privacyPolicy: {
      title: 'Adatvédelmi nyilatkozat',
      lastUpdated: 'Utoljára frissítve',
      introduction: 'Nagyon komolyan vesszük adatai védelmét. Ez az adatvédelmi nyilatkozat elmagyarázza, hogyan dolgozzuk fel személyes adatait.',
      sections: {
        responsible: {
          title: '1. Felelős fél',
          content: 'A GDPR értelmében a személyes adatok kezeléséért felelős fél: Sören Padel, Örträsk 48. 935 93 Norsjö, Svédország, info@alitero.eu, +49 157 3004 1651'
        },
        dataCollection: {
          title: '2. Adatgyűjtés és feldolgozás',
          intro: 'Csak akkor gyűjtünk és dolgozunk fel személyes adatokat, amikor jogszerű és meghatározott célra szükséges. Az adatokat az alábbiak szerint dolgozzuk fel:',
          contact: 'Kapcsolati űrlapok: Amikor használja a kapcsolati űrlapunkat, gyűjtjük a nevét, e-mail-címét és az Ön által megadott egyéb információkat. Ezeket az adatokat kizárólag a kérdésre adott válaszhoz használjuk.',
          analytics: 'Weboldal-analitika: Nem használunk harmadik féltől származó nyomkövetési eszközöket, amelyek az Ön adatait külső szerverekre küldik.'
        },
        purposes: {
          title: '3. Adatfeldolgozás céljai',
          intro: 'Az Ön adatait a következő célokra dolgozzuk fel:',
          items: [
            'Kérdésekre válaszadás az kapcsolati űrlap segítségével',
            'Kommunikáció Önnel tervezett vagy befejezett weboldal-projektek kapcsán',
            'Jogi kötelezettségek teljesítése (pl. üzleti dokumentumok megőrzése)'
          ]
        },
        legalBasis: {
          title: '4. Jogi alap',
          content: '**A személyes adatok kezelésének jogalapja**\n\nAz Ön személyes adatainak kezelése az Európai Unió általános adatvédelmi rendeletének (GDPR) 6. cikk (1) bekezdésével és a német adatvédelmi törvénnyel összhangban történik. Személyes adatait a következő jogalapok alapján kezeljük:\n\n**Szerződés teljesítése (GDPR 6. cikk (1) bekezdés b) pont):** Személyes adatait akkor kezeljük, amikor ez az Önnel kötött szerződés teljesítéséhez vagy az Ön kérésére a szerződéskötést megelőző intézkedések megtételéhez szükséges.\n\n**Hozzájárulás (GDPR 6. cikk (1) bekezdés a) pont):** Bizonyos esetekben azután kezeljük személyes adatait, hogy Ön kifejezett hozzájárulását adta. Önnek bármikor joga van visszavonni hozzájárulását.\n\n**Jogos érdek (GDPR 6. cikk (1) bekezdés f) pont):** Személyes adatait akkor kezelhetjük, ha ez jogos érdekeink érvényesítéséhez szükséges, kivéve ha az Ön érdekei vagy alapvető jogai és szabadságai elsőbbséget élveznek. Az ilyen jogos érdekek magukban foglalhatják szolgáltatásaink fejlesztését, a biztonságot és a marketinget.\n\n**Jogi kötelezettség (GDPR 6. cikk (1) bekezdés c) pont):** Személyes adatait akkor kezeljük, amikor erre törvényileg kötelesek vagyunk, például könyvelési célokból.'
        },
        dataSharing: {
          title: '5. Harmadik feleknek való átadás',
          content: 'Személyes adatait nem adjuk át harmadik feleknek, hacsak azt nem írja elő a törvény (pl. jogi kötelezettségek teljesítése) vagy kifejezetten nem járult hozzá. Az Ön adatai nem kerülnek harmadik feleknek marketing céljára.'
        },
        storage: {
          title: '6. Tárolás időtartama',
          content: 'Személyes adatait csak a meghatározott célok teljesítéséhez szükséges ideig tároljuk. Projekt befejezése után vagy ajánlatkérés elutasítása után adatait legkésőbb 3 év múlva töröljük, ha a törvény nem ír elő hosszabb tárolási időt (pl. üzleti dokumentumok).'
        },
        rights: {
          title: '7. Az Ön jogai',
          intro: 'Személyes adataira vonatkozóan az alábbi jogokkal rendelkezik (GDPR 15-22. cikk):',
          items: [
            'Hozzáférési jog: Bármikor kérheti személyes adataira vonatkozó információt.',
            'Helyesbítés joga: Kérheti a helytelen adatok kijavítását.',
            'Törlés joga: Bizonyos feltételek mellett kérheti adatainak törlését.',
            'Feldolgozás korlátozása: Kérheti, hogy adatainak feldolgozása korlátozódjon.',
            'Adathordozhatóság joga: Adatait strukturált, általános és géppel olvasható formátumban kaphatja meg.',
            'Tiltakozás joga: Tiltakozhat az Ön adatainak feldolgozása ellen.'
          ]
        },
        contact: {
          title: '8. Kapcsolat az adatvédelemmel kapcsolatos kérdésekhez',
          content: 'Ha szeretné gyakorolni jogait vagy kérdése van az adatvédelemmel kapcsolatban, kérjük, vegye fel velünk a kapcsolatot: [E-mail], [Telefon].'
        },
        cookies: {
          title: '9. Sütik és hasonló technológiák',
          content: 'Ez a weboldal nem használ személyes követő sütiket. Szolgáltatásaink javítása érdekében Umami Analytics-t használunk, egy adatvédelmi barát elemzőeszközt, amely teljesen névtelensített módon gyűjti a látogatói adatokat. Nem kerülnek tárolásra IP-címek és nem kerülnek begyűjtésre személyes adatok. Az elemzés kizárólag statisztikai célokat szolgál.'
        },
        security: {
          title: '10. Adatbiztonság',
          content: 'Technikai és szervezeti intézkedéseket alkalmazunk adatai védelme érdekében a visszaélés, veszteség és jogosulatlan hozzáférés ellen. Az összes átvitel biztonságos HTTPS-kapcsolaton keresztül történik. Azonban nem garantálhatunk abszolút biztonságot.'
        },
        thirdParties: {
          title: '11. Külső szolgáltatások',
          intro: 'Ez a weboldal a következő külső szolgáltatásokat használja:',
          umami: 'Umami Analytics: Névtelen használatelemzéshez. Nem kerülnek begyűjtésre személyes adatok. További információ: https://umami.is/docs/privacy',
          staticforms: 'Űrlapfeldolgozás: Megkereséseit kizárólag saját, németországi szerverünkön dolgozzuk fel (saját üzemeltetésű Supabase), és e-mailben továbbítjuk magunknak. Harmadik félnek nem adunk át adatokat.'
        },
        changes: {
          title: '12. Az adatvédelmi nyilatkozat módosulása',
          content: 'Fenntartjuk magunknak a jogot, hogy ezt az adatvédelmi nyilatkozatot bármikor módosítsuk. A módosítások ezen az oldalon kerülnek közzétételre. Kérjük, rendszeresen tekintse át.'
        }
      }
    },
    requestForm: {
      title: 'Ajánlatkérés',
      subtitle: 'Meséljen a terveiről. Töltse ki ezt az űrlapot, hogy képet kaphassak az elképzeléseiről.',
      wizard: {
        step: 'Lépés',
        of: '/',
        next: 'Tovább',
        back: 'Vissza',
        review: 'Összefoglaló',
        reviewHint: 'Kérjük, ellenőrizze adatait, mielőtt elküldi a kérést.',
        notSpecified: 'Nincs megadva',
        stepNames: {
          1: 'Kapcsolat és cég',
          2: 'Weboldal és terjedelem',
          3: 'Költségvetés és együttműködés',
          4: 'Ellenőrzés és küldés'
        },
        errors: {
          name: 'Kérjük, adja meg a nevét.',
          email: 'Kérjük, adjon meg egy érvényes e-mail címet.'
        }
      },
      sections: {
        contact: 'Kapcsolati adatok',
        company: 'Vállalkozás',
        website: 'Jelenlegi weboldal státusz',
        scope: 'Terjedelem és tartalom',
        details: 'Projekt részletei',
        budget: 'Költségvetés és időkeret',
        cooperation: 'Együttműködés'
      },
      fields: {
        name: 'Név',
        email: 'E-mail cím',
        phone: 'Telefonszám (opcionális)',
        company: 'Cég / Szervezet (opcionális)',
        industry: 'Iparág / Tevékenységi kör',
        location: 'Helyszín (Város / Ország)',
        websiteLink: 'Link a meglévő weboldalhoz',
        goals: 'Mit teljesítsen a weboldala?',
        notes: 'Van valami, ami különösen fontos Önnek az együttműködésben?',
        otherLanguage: 'Egyéb nyelv',
        otherScope: 'Egyéb / Speciális igények'
      },
      options: {
        status: {
          none: 'Még nincs weboldalunk.',
          new: 'Van weboldalunk, de újat szeretnénk.',
          relaunch: 'Weboldalunkat át kell dolgozni.'
        },
        scope: {
          home: 'Kezdőlap / Áttekintés',
          services: 'Szolgáltatások / Ajánlat',
          about: 'Rólunk / Csapat',
          contact: 'Kapcsolat oldal',
          forms: 'Egyedi űrlapok',
          blog: 'Blog / Hírek',
          multi: 'Többnyelvűség',
          other: 'Egyéb / Speciális igények'
        },
        languages: {
          de: 'Német',
          en: 'Angol',
          sv: 'Svéd',
          hu: 'Magyar',
          other: 'Egyéb'
        },
        budget: {
          label: 'Költségvetés becslés (nem kötelező)',
          unknown: 'Még nincs pontos elképzelésem',
          small: 'Kisebb keret (egyszerű, kompakt weboldal)',
          medium: 'Közepes keret (több aloldal)',
          large: 'Nagyobb keret (speciális igények)'
        },
        timeline: {
          label: 'Időkeret',
          asap: 'Amint lehetséges',
          months: 'A következő 1-3 hónapban',
          later: 'Később, egyelőre csak tájékozódom'
        },
        support: {
          maintenance: 'Folyamatos támogatást kérek (módosításokkal).',
          hosting: 'Domain és hosting ügyintézést kérek.'
        }
      },
      privacy: {
        text: 'Az űrlap elküldésével hozzájárul ahhoz, hogy adatait a kérés feldolgozása érdekében kezeljem.',
        checkbox: 'Igen, elolvastam az adatvédelmi nyilatkozatot és elfogadom.'
      },
      submit: 'Kötelezettség nélküli ajánlatkérés küldése',
      success: 'Köszönöm megkeresését! Hamarosan jelentkezem.',
      errorSend: 'A kérést nem sikerült elküldeni. Kérjük, próbálja újra később, vagy írjon az info@alitero.eu címre.',
      errorRateLimited: 'Túl sok kérés. Kérjük, próbálja újra később, vagy írjon az info@alitero.eu címre.',
      errorDisposable: 'Kérjük, állandó e‑mail címet adjon meg – eldobható címre nem tudunk válaszolni.',
      errorStale: 'Az űrlap túl sokáig volt nyitva. Töltse újra az oldalt, és küldje el ismét.'
    },
    imprint: {
      title: 'Impresszum',
      lastUpdated: 'Utoljára frissítve',
      introduction: 'A jogszabály által előírt adatok',
      sections: {
        responsible: {
          title: 'A tartalom felelőse',
          name: 'Sören Padel',
          address: 'Örträsk 48, 935 93 Norsjö, Svédország',
          email: 'E-mail: info@alitero.eu',
          phone: 'Telefon: +49 157 3004 1651'
        },
        eu: {
          title: 'EU vitarendezés',
          content: 'Az Európai Bizottság online vitarendezési platformot (ODR) biztosít. Ezt a platformot a https://ec.europa.eu/consumers/odr/ címen találja.'
        },
        liability: {
          title: 'Felelősségkizárás',
          intro: 'A gondos és alapos tartalomvédelem ellenére nem vállalunk felelősséget a külső linkek tartalmáért. A hivatkozott oldalak kezelői kizárólag saját tartalmukért felelnek.',
          accuracy: 'A weboldal tartalma gondosan és lelkiismeretesen készül és rendszeresen frissül. Azonban nem tudjuk garantálni az összes tartalom aktualitását, pontosságát és teljességét.',
          liability_clause: 'A szerzővel szemben támasztott kártérítési igények, amelyek a bemutatott információ használatából vagy meg nem használásából, illetve a helytelen és hiányos információ használatából eredő anyagi vagy nem anyagi jellegű kárra vonatkoznak, alapvetően kizártak.'
        },
        copyright: {
          title: 'Szerzői jog',
          content: 'Az ezen a weboldal közzétett tartalom szerzői jog által védett. A szerzői jogok nem engedélyezett felhasználása a szerző vagy jogosult előzetes kifejezett beleegyezését igényli. Ez különösen a másolásra, szerkesztésre, fordításra, tárolásra, elektronikus rendszerekben történő feldolgozásra és terjesztésre vonatkozik.'
        },
        dataprivacy: {
          title: 'Adatvédelem',
          content: 'Komolyan vesszük személyes adatai védelmét. Az adatvédelmi irányelveinket az "Adatvédelem" szakaszban találja.'
        },
        disclaimer: {
          title: 'Tartalom felelősségkizárása',
          content: 'Szolgáltatóként saját tartalmakért felelünk ezeken az oldalakon az általános jogszabályok szerint. A szolgáltatóként azonban nem kötelezek a továbbított vagy tárolt harmadik fél által nyújtott információk felügyeletét vagy az illegális tevékenységet jelző körülmények vizsgálatát.'
        }
      }
    },
    about: {
      title: 'Rólam – Sören Padel / Alitero',
      greeting: 'Szia,',
      intro: 'a nevem Sören Padel (Szőren Pádel). Az Alitero egy latin alapú neologizmus, amely azt jelöli, aki tudatosan egy kicsit másképp közelíti meg a dolgokat.',
      aliteroMeaning: 'Pontosan ez a megközelítésem: olyan megoldások, amelyek nem a polcról jönnek, hanem Önhöz és projektjéhez illeszkednek.',
      background: {
        title: 'Szakmai Háttér',
        intro: 'Körülbelül 25 éve fejlesztek weboldalakat – először személyes érdeklődésből és saját projektekhez, most már professzionálisan is ügyfeleknek. Valójában:',
        roles: [
          'Történész vagyok',
          'IT-orientált geográfus – és így kartográfus és demográfus is',
          'Pedagógus és Svédország-szakértő',
          'sok éves tapasztalattal az ökológiai gazdálkodásban és a regionális fejlesztésben'
        ],
        summary: 'Ez a humán- és térbeli tudományok, a mezőgazdaság és regionális fejlesztés gyakorlata, valamint a pedagógiai tapasztalat keveréke a munkám alapja: Kutatni, strukturálni, érthetően elmagyarázni és úgy előkészíteni a tartalmat tudom, hogy az célcsoportjai számára megfoghatóvá váljon.'
      },
      tools: {
        title: 'Az Én Kedvenc Eszközeim és Programjaim',
        intro: 'Az eszköztáramban megtalálható, többek között:',
        items: [
          { category: 'Fejlesztés', tool: 'VSCodium' },
          { category: 'Adatok', tool: 'RStudio' },
          { category: 'Térképek & GIS', tool: 'QGIS, OpenLayers' },
          { category: 'Média', tool: 'Affinity Suite, Fooocus, DaVinci Resolve Studio, Audacity, OBS Studio' },
          { category: 'Tudományos Munka', tool: 'TeXstudio, Zotero' },
          { category: 'Együttműködés & Fájltárolás', tool: 'Nextcloud' }
        ],
        conclusion: 'Munkakörnyezetem szándékosan interdiszciplináris. Ahol alkalmas, a nyílt forráskódra hagyatkozom – nem öncélból, hanem a függőségek csökkentése és a projektek hosszú távú fenntarthatósága érdekében.'
      },
      personal: {
        title: 'Ki Vagyok a Képernyőn Kívül',
        intro: 'Szabadidőmben:',
        hobbies: [
          'Méhész',
          'Szolgálati kutyás sportoló',
          'Hobbisörfőző'
        ],
        conclusion: 'Ezeknek a tevékenységeknek egy közös vonása van: Türelmet, pontosságot, felelősséget és az egészre való rálátást igénylik. Ez a hozzáállás alakítja a weboldalakkal, szövegekkel, grafikákkal és dokumentumfilmekkel kapcsolatos munkámat is.'
      },
      cta: {
        welcome: 'Üdvözöllek az Alitero-nál.',
        message: 'Ha olyan weboldalt, szövegeket vagy dokumentumfilmet keresel, amelyek szakmailag megalapozottak, érthetőek és részletekre odafigyeléssel készültek, várom üzeneted.',
        signature: 'Üdvözlettel, Sören Padel',
        button: 'Kapcsolatfelvétel'
      }
    }
  }
};

// TEST 123